/* eslint-disable */
<template>
  <div class="create-booking">
    <AdminNavigation ref="navigation" indexProps="5" />
    <div class="top-panel no-sub-title">
      <Header />
      <div class="header-title-section">
        <div class="header-title"><h1>{{ setTitle() }}</h1></div>
      </div>
    </div>
    <div class="panel no-sub-title">
      <AdminBookingsMenu :key="0" :indexProps="0" />
      <div class="content">
        <div class="top-detail pt-2">
          <div class="row m-0">
            <div class="col-4 p-0 center-title">
              <div class="row center-title m-0 display-in-row" v-if="!bookingObject.isSupplementary">
                <div class="col-2 p-0" v-if="booking.bookingDateTime != ''">
                  <div class="border-image">
                    <div class="border-image-number">{{formatDate(booking.bookingDateTime, 'DD', 'YYYY-MM-DD HH:mm:ss')}}</div>
                    <div class="border-image-text">{{formatDate(booking.bookingDateTime, 'MMM, YYYY hh:mm A', 'YYYY-MM-DD HH:mm:ss')}}</div>
                  </div>
                </div>
                <div class="col center-title ml-4">
                  {{getShortLocationName()}}
                </div>
              </div>
            </div>
            <div class="col-3 center-title p-0">
              <div v-if="this.clientCase|| booking.claimantFullName != '' && booking.dateOfBirth != '' && booking.claimTypeName != ''">
                <div class="name" v-if="booking.claimantFullName">{{decodeURIComponent(booking.claimantFullName)}}</div>
                <p v-if="booking.dateOfBirth != ''">D.O.B.  {{formatDate(booking.dateOfBirth, 'DD/MM/YYYY')}}</p>
                <p v-if="booking.claimTypeName != ''">Type:  {{booking.claimTypeName}}</p>
                <p v-if="booking.caseOwnerName != ''">Case Owner:  {{booking.caseOwnerName}}</p>
              </div>
            </div>
            <div class="col p-0">
              <div class="row m-0">
                <div class="col-2 p-0">
                  <div class="rounded-image medium-rounded-image m-t-0 m-t-b" v-if="specialist.ProfileThumbnail">
                    <div class="profile-image-content"><img :src="specialist.ProfileThumbnail" /></div>
                  </div>
                  <div class="box-col" v-else>
                    <div class="rounded-image medium-rounded-image m-t-0 m-t-b">
                      <div class="profile-image-content notice-background"><s class="text-initials">{{getInitials(specialist)}}</s></div>
                    </div>
                  </div>
                </div>
                <div class="col center-title ml-4">
                  <div>
                    <div class="name">
                      {{specialist.fullName}}
                      <img v-if="requiresTravel" class="icon-20" src="@/assets/images/travel_black_circle_icon.svg" />
                      <img v-if="videoLinkAvailable == 2" class="icon-20 ml-2" src="@/assets/images/video_black_icon.svg" />
                    </div>
                    <div>
                      {{getSpecialistInfo(specialist.practiceLocationId, specialist.locations)}}
                    </div>
                    <div>
                      {{getBookingTypeById(this.booking.bookingTypeId)}}
                    </div>
                    <div v-if="booking.videoLinkTestStatus" class="is-icon"><img src="@/assets/images/video_black_icon.svg" /></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="box" v-if="displayBookingDetails">
          <div class="box-heading d-flex align-items-center">Booking Details</div>
          <div class="box-body">
            <div class="box-row" >
              <div class="box-col box-col-left left-label">Client</div>
              <div class="box-col box-col-right align-items-center">
                <el-input disabled :value="decodeURIComponent(client.ClientName)" />
                <div class="text-danger mt-5" v-if="hasError && clientIdError">
                  {{ clientIdError }}
                </div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left left-label required">Client Contact</div>
              <div class="box-col box-col-right align-items-center d-flex">
                <div class="d-flex align-items-center w-100">
                  <el-select placeholder="Select Contact" class="w-75" :class="hasError && caseOwnerError ? 'is-invalid' : ''" v-model="booking.clientContact" @change="onChangeContact">
                    <el-option v-for="item in clientContacts" :value="item.id" :key="item.id" :label="item.name">{{item.name}}</el-option>
                  </el-select>
                  <button class="btn" data-toggle="tooltip" data-placement="right" title="Create New Contact" @click="addNewContact">
                    <img class="w-75" src="@/assets/images/add_black_icon.svg" />
                  </button>
                </div>
                <div class="text-danger mt-5" v-if="hasError && caseOwnerError">
                  {{ caseOwnerError }}
                </div>
              </div>
            </div>
            <div class="box-row" >
              <div class="box-col box-col-left left-label required">Service Type</div>
              <div class="box-col box-col-right">
                <el-select
                  v-model="booking.bookingTypeId"
                  @change="onChangeBookingType"
                  class="w-50"
                  :class="hasError && bookingTypeError ? 'is-invalid' : ''">
                  <el-option v-for="type in bookingTypes" :key="type.id" :value="type.id" :label="type.name">
                    {{ type.name }}
                  </el-option>
                </el-select>
                <v-btn class="ml-4" :class="ShowVideoLinkUrl ? 'reverse-btn' : ''" small @click="switchShowLink" v-if="booking.bookingTypeId === 7" dark>{{ShowVideoLinkUrl ? 'Change to Phone Call' : 'Change to VideoLink Call'}}</v-btn>
                <div v-if="hasError && bookingTypeError" class="text-danger">
                  {{ bookingTypeError }}
                </div>
              </div>
            </div>
            <div class="box-row" v-if="booking.specialistAvailabilityId && showDelivery">
              <div class="box-col box-col-left left-label required">Delivery Method</div>
              <div class="box-col box-col-right box-center">
                <el-select v-model="booking.DeliveryMethodID" class=" w-75" @change="onSelectMethod" :key="methodKey" :class="hasError && deliveryMethodError ? 'is-invalid' : ''" >
                  <el-option v-for="item in deliveryMethods" :value="item.value" :label="item.label" :key="item.value"
                             title="item.des"></el-option>
                </el-select>
                <div v-if="hasError && deliveryMethodError" class="text-danger pl-2">{{ deliveryMethodError }}</div>
              </div>
            </div>
            <div class="box-row" v-if="booking.bookingTypeId === 19" >
              <div class="box-col box-col-left left-label required">Number of services</div>
              <div class="box-col box-col-right">
                <el-checkbox v-model="showMAS" @change="onChangeNum('MAS', $event)" class="default-checkbox tick">MAS</el-checkbox> <el-input-number v-show="showMAS" :controls="false" style="width: 50px" v-model="booking.MAS" controls-position="right" :min="1" step-strictly :max="10"></el-input-number>
                <el-checkbox v-model="showPIC" @change="onChangeNum('PIC', $event)" class="default-checkbox tick">PIC</el-checkbox> <el-input-number v-show="showPIC" :controls="false" style="width: 50px"  v-model="booking.PIC" controls-position="right" :min="1" step-strictly :max="10"></el-input-number>
                <el-checkbox v-model="showSHORT" @change="onChangeNum('ShortReport', $event)" class="default-checkbox tick">Short Report</el-checkbox> <el-input-number v-show="showSHORT" :controls="false" style="width: 50px"  v-model="booking.ShortReport" controls-position="right" step-strictly :min="1" :max="10"></el-input-number>
                <span>(<b>Please Note - </b>Short Report requests must be 5 questions or less).</span>
                <div v-if="hasError && numOfServicesError" class="text-danger pl-2">{{ numOfServicesError }}</div>
              </div>
            </div>
            <div class="box-row" v-if="!disableCaseField" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left left-label required">Examinee Name</div>
              <div class="box-col box-col-right">
                <div v-if="!isEditName" @click="openAddNameModal" :key="nameKey" class="parent is-icon full-width-div">
                  <input type="text" disabled class="child px-3 placeholder-opacity" placeholder="Please click here to enter the Examinee details"/>
                </div>
                <span v-else :key="nameKey" @click="openAddNameModal" >
                  <input :value="decodeURIComponent(booking.claimantFullName)" placeholder="Please click here to enter the Examinee details" />
                </span>
                <div class="text-danger" v-if="hasError && claimantNameErrors">
                  {{ claimantNameErrors }}
                </div>
              </div>
              <AddNameModal ref="addNameModal" @setName="setName"/>
            </div>
            <div class="box-row" v-if="!disableCaseField && !isTPD" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left left-label">Examinee Salutation</div>
              <div class="box-col box-col-right">
                <el-select :disabled="disableCaseField" class="w-50" v-model="booking.Salutation" filterable clearable placeholder="Examinee Salutation">
                  <el-option v-for="item in salutationList" :key="item.value" :value="item.value" :label="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="box-row" v-if="!disableCaseField" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left left-label required">Client Reference Number</div>
              <div class="box-col box-col-right">
                <input class="textbox" type="text" placeholder="Client reference number" maxlength="40" :class="hasError && clientReferenceError ? 'is-invalid' : ''" v-model="booking.ClientReference" @blur="trimBookingField('ClientReference')" />
                <div v-if="hasError && clientReferenceError" class="text-danger">{{ clientReferenceError }}</div>
              </div>
            </div>
            <div class="box-row" v-if="booking.bookingTypeId === 8" >
              <div class="box-col box-col-left left-label">Future Date this Supp</div>
              <div class="box-col box-col-right box-col-center">
                <el-date-picker
                    popper-class="date-range-picker-popper"
                    type="datetime"
                    clearable
                    :picker-options="pickerOptions"
                    class="w-50"
                    v-model="booking.SuppFutureDate"
                    format="dd/MM/yyyy HH:mm" :typeable="true"
                    placeholder="dd/mm/yyyy"></el-date-picker>
              </div>
            </div>
            <div class="box-row" >
              <div  class="box-col box-col-left left-label required">State where the incident occurred</div>
              <div class="box-col box-col-right">
                <el-select v-model="booking.IncidentState" :class="hasError && incidentStateError ? 'is-invalid' : ''" >
                  <el-option v-for="state in states" :key="state.value" :value="state.value" :label="state.text">{{ state.text }}</el-option>
                  <el-option value="International" label="International">International</el-option>
                </el-select>
                <div v-if="hasError && incidentStateError" class="text-danger">{{ incidentStateError }}</div>
              </div>
            </div>
            <div class="box-row" v-if="!disableCaseField && !isTPD" :class="disableCaseField ? 'disabled-element' : ''">
              <div  class="box-col box-col-left left-label">Examinee Preferred Name</div>
              <div class="box-col box-col-right">
                <input :disabled="disableCaseField" class="textbox referance" type="text" placeholder="Examinee Preferred Name" v-model="booking.PreferredGivenName" :class="hasError && preferredGivenNameError ? 'is-invalid' : ''" @blur="trimBookingField('PreferredGivenName')" />
                <div v-if="hasError && preferredGivenNameError" class="text-danger">{{ preferredGivenNameError }}</div>
              </div>
            </div>
            <div class="box-row" v-if="!disableCaseField" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left left-label">Date of Birth</div>
              <div class="box-col box-col-right box-col-center">
                <el-date-picker
                  class="w-50 date-of-birth"
                  :disabled="disableCaseField"
                  v-model="booking.dateOfBirth"
                  @change="checkReassessments"
                  format="dd/MM/yyyy" :typeable="true"
                  placeholder="dd/mm/yyyy"></el-date-picker>
                  <div v-if="hasError && dateOfBirthError" class="text-danger">{{ dateOfBirthError }}</div>
              </div>
            </div>
            <div class="box-row" v-if="booking.Reassessment">
              <div class="box-col box-col-left left-label">Re-assessment</div>
              <div class="box-col box-col-right box-col-center">
                <input type="checkbox" :checked="!!booking.Reassessment" :disabled="booking.Reassessment"  />
              </div>
            </div>
            <div class="box-row" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left left-label">Examinee Contact Details</div>
              <div class="box-col box-col-right">
                <div v-if="!isEditContact" @click="openManageContactDetails" class="parent is-icon full-width-div">
                  <input type="text" class="child placeholder-opacity" disabled placeholder="Please click here to enter contact details" />
                </div>
                <div v-else @click="openManageContactDetails" class="padding-left-10 w-50 h-100 cursor-pointer">
                  <span v-if="this.booking.claimantMobile" class='text-bold'>M: </span> {{ this.booking.claimantMobile }}
                  <span v-if="this.booking.claimantEmail" class='text-bold'>E: </span> {{ decodeURIComponent(this.booking.claimantEmail) }}
                  <span v-if="this.booking.claimantPhone1" class='text-bold'>P: </span> {{ this.booking.claimantPhone1 }}
                  <span v-if="this.booking.claimantPhone2" class='text-bold'>L: </span> {{ this.booking.claimantPhone2 }}
                </div>
                <div v-if="hasError && contactDetailsError && !disableCaseField" class="text-danger" style="position: absolute; z-index: 1; top: 30px;">{{ contactDetailsError }}</div>
                <AddClientContactModal ref="addClientContactModal" :typrProps="'fromBooking'"/>
              </div>
            </div>
            <div class="box-row" v-if="!disableCaseField">
              <div class="box-col box-col-left left-label">Examinee Address</div>
              <div class="box-col box-col-right">
                <div v-if="!isEditAddress" class="parent is-icon full-width-div" @click="openManageAddress">
                  <input class="child placeholder-opacity w-100" disabled placeholder="Please click here to update claimant's address" />
                </div>
                <span v-else @click="openManageAddress">{{booking.claimantFullAddress}}</span>
                <div  class="is-icon right-float-element" @click="openManageAddress">
                </div>
                <AddClientAddressModal ref="addClientAddressModal" :typrProps="'fromBooking'"/>
              </div>
            </div>
            <div v-if="(ShowVideoLinkUrl && booking.bookingTypeId === 7)" class="box-row">
              <div class="box-col box-col-left left-label">Video Link URL</div>
              <div class="box-col box-col-right">
                <el-input type="text" maxlength="255" class="video-link-url  w-75" v-model="booking.VideoLinkURL" placeholder="Video Link URL" />
              </div>
            </div>
            <div v-if="booking.DeliveryMethodID === 2 && showDelivery" class="box-row">
              <div class="box-col box-col-left left-label">Examinee Location for VideoLink</div>
              <div class="box-col box-col-right">
                <input :disabled="booking.bookingStatus === 6"  type="text" :class="hasError && examineeLocationError ? 'is-invalid' : ''" class="px-3" maxlength="255" v-model="booking.ClaimantLocation" placeholder="Examinee Location for VideoLink" />
                <div v-if="hasError && examineeLocationError" class="text-danger pl-2">{{ examineeLocationError }}</div>
              </div>
            </div>
            <div v-if="booking.DeliveryMethodID === 2 && !isTPD" class="box-row">
              <div class="box-col box-col-left left-label required">{{booking.bookingTypeId === 7 ? 'Client State for Phone Call' : 'Examinee State During Booking'}}</div>
              <div class="box-col box-col-right">
                <div class="pl-2">Which state will your claimant be located in for the appointment?</div>
                <el-cascader
                    popper-class="search-no-scroll-panel"
                    style="min-width: 250px"
                    v-model="bookingExamineeStatus"
                    :options="options"
                    :class="hasError && examineeStateError ? 'is-invalid' : ''"
                    @change="handleChange"></el-cascader>
                <span v-if="timeZoneValue" class="ml-2">{{timeZoneValue}}</span>
                <div v-if="hasError && examineeStateError" class="text-danger pl-2">{{ examineeStateError }}</div>
              </div>
            </div>
            <div class="box-row" v-if="!isTPD">
              <div class="box-col box-col-left left-label">Booking Details</div>
              <div class="box-col box-col-right d-flex align-items-center">
                <img
                  class="ml-2 is-icon"
                  src="@/assets/images/claimant_attendance_icon.svg"
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="getAttendanceTitle"
                  :data-original-title="getAttendanceTitle"
                  @click="toggleAttendance()"
                  :class="booking.claimantConfirmed == true ? '' : 'disabled-element'"
                />
                <img
                  class="ml-2 is-icon"
                  src="@/assets/images/can_ring_claimant_icon.svg"
                  @click="toggleCanRingClaimant()"
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="getCanRingClaimantTitle"
                  :data-original-title="getCanRingClaimantTitle"
                  :class="booking.redHealthMayContactClaimant == true ? '' : 'disabled-element'" />
                <img
                  class="ml-2 is-icon"
                  src="@/assets/images/consent_received_icon.svg"
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="getConsentReceivedTitle"
                  :data-original-title="getConsentReceivedTitle"
                  @click="toggleConsentReceived()"
                  :class="booking.claimantConsentReceived == true ? '' : 'disabled-element'" />
                <img
                  class="is-icon"
                  src="@/assets/images/call_after_appointment_icon.svg"
                  @click="toggleCallAfterAppointment()"
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="getCallAfterAppointmentTitle"
                  :data-original-title="getCallAfterAppointmentTitle"
                  :class="booking.callClientAfterAppointment == true ? '' : 'disabled-element'" />
                <img
                  class="ml-4 is-icon"
                  src="@/assets/images/video_link_test_arranged_icon.svg"
                  @click="toggleVideoLinkTestArranged()"
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="getVideoLinkTestArrangedTitle"
                  :data-original-title="getVideoLinkTestArrangedTitle"
                  :class="booking.videoLinkTestStatus == 1 || booking.videoLinkTestStatus == 2 ? '' : 'disabled-element'"
                  v-if="booking.bookingTypeId == 4"
                />
                <img
                  class="ml-2 is-icon"
                  src="@/assets/images/video_link_test_icon.svg"
                  data-toggle="tooltip"
                  data-placement="right"
                  :title="getHasVideoTitle"
                  :data-original-title="getHasVideoTitle"
                  @click="toggleHasVideo()"
                  :class="booking.hasVideoLink == true ? '' : 'disabled-element'"
                  v-if="booking.bookingTypeId == 4"
                />
              </div>
            </div>

            <div class="box-row">
              <div class="box-col box-col-left left-label">Acting on behalf of</div>
              <div class="box-col box-col-right">
                <el-select v-model="booking.onBehalfOf" class="w-100" filterable clearable>
<!--                  <el-option label="Non Red Health Client"></el-option>-->
                  <el-option v-for="item in originalListClients" :key="item.id" :value="item.fullName" :label="item.fullName"></el-option>
                </el-select>
              </div>
            </div>

            <div class="box-row">
              <div class="box-col box-col-left left-label">Date of Accident/Event</div>
              <div class="box-col box-col-right box-col-center" style="display: flex;">
                <datepicker
                  :disabled="booking.overPeriodofTime"
                  class="w-50 accient-date"
                  format="dd/MM/yyyy"
                  :typeable="true"
                  placeholder="dd/mm/yyyy"
                  @selected="changeDate"
                  v-model="booking.accidentDate">
                </datepicker>
                  <div style="display: flex;align-items: center; padding-left: 10px;">
                    <toggle-button  @change="onChartToggleChange(4)" class="togglePeriodOfTime" :color="{checked: '#56C568', unchecked: '#525252'}" :width="40" :sync="true" :value="booking.overPeriodofTime"/>  Over a period of time
                  </div>
              </div>
            </div>
            <div class="box-row" :class="disableCaseField ? 'disabled-element' : ''">
              <div class="box-col box-col-left left-label" :class="isTPD ? '' : 'required'">Referral Type</div>
              <div class="box-col box-col-right">
                <el-select :disabled="disableCaseField || isTPD" v-model="booking.claimTypeId" @change="changedClaimantType($event)" allowClear :class="hasError && referralTypeError ? 'is-invalid' : ''" class="w-50">
                  <el-option v-for="claimType in claimTypes" :key="claimType.id" :value="claimType.id" :label="claimType.name">{{ claimType.name }}</el-option>
                </el-select>
                <div class="text-danger" v-if="hasError && referralTypeError">
                  {{ referralTypeError }}
                </div>
              </div>
            </div>
            <div class="box-row">
              <div  class="box-col box-col-left left-label">Affected Body Areas</div>
              <div class="box-col box-col-right box-col-center">
                <vue-tags-input
                  class="pr-10"
                  v-model="bodyAreaTag"
                  :tags="bodyAreaTags"
                  placeholder="Add Affected Body Areas"
                  :autocomplete-items="filteredBodyAreaItems"
                  @tags-changed="(newTags) => (bodyAreaTags = newTags)"
                  @focus="openDigram()"
               />
              </div>
              <div @click="openBodyDiagram" class="center-item">
                <img src="@/assets/images/choose.svg" alt="" class="right-element align-self-center is-icon pr-3"/>
              </div>
              <AddBodyDiagramModal style="top: 0px" ref="addBodyDiagramModal" />
            </div>
            <div class="box-row">
              <div class="box-col box-col-left left-label">Other Body Areas</div>
              <div class="box-col box-col-right box-col-center">
                <vue-tags-input
                  v-model="otherBodyAreaTag"
                  :tags="otherBodyAreaTags"
                  :placeholder="this.booking.caseId == '' ? 'Add Other Body Areas':''"
                  @tags-changed="(newTags) => (otherBodyAreaTags = newTags)" />
                <div v-if="hasError && otherBodyAreasError" class="text-danger w-100">{{ otherBodyAreasError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left left-label">Conditions</div>
              <div class="box-col box-col-right box-col-center">
                <el-select  placeholder="Add Conditions" class="w-100" v-model="booking.PersonConditions" multiple clearable filterable>
                  <el-option v-for="item in personConditions" :value="item.value" :label="item.text" :key="item.value"></el-option>
                </el-select>
              </div>
            </div>

            <div class="box-row" v-if="booking.bookingTypeId !== 19">
              <div class="box-col box-col-left left-label">
                Interpreter Details
              </div>
              <div @click="openInterpreterDetail" class="box-col box-col-right cursor-pointer">
                <el-input :readonly="true" type="text" class="px-3" maxlength="255" v-html="getInterpreterDetail()" placeholder="Click to add interpreter details if required" />
              </div>
            </div>
            <div class="box-row" v-if="booking.DeliveryMethodID === 2">
              <div class="box-col box-col-left left-label">
                Surrogate Details
              </div>
              <div @click="openSurrogateDetail" class="box-col box-col-right cursor-pointer">
                <el-input  :readonly="true"
                  type="text" v-html="getSurrogateDetail()"
                  maxlength="255"
                  placeholder="Click to add surrogate details if required"
                />
              </div>
            </div>
            <div class="box-row" v-if="!isTPD && !bookingWithNoAvailability">
              <div class="box-col box-col-left left-label">Paperwork Due</div>
              <div class="box-col box-col-right">
                <input
                  v-model="booking.paperworkDue"
                  class="w-50"
                  :disabled="true"
                  placeholder="DD/MM/yyyy" />
                <!-- <span class="right-element">LOI Received</span> -->
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left left-label">Send Report To</div>
              <div class="box-col box-col-right">
                <el-select @change="selectedSendTo" placeholder="Select a Client"  class="w-100" v-model="booking.reportTo" filterable clearable>
                  <el-option v-for="contact in listBillTo" :key="contact.value" :value="contact.value" :label="contact.name">{{ contact.name }}</el-option>
                  <el-option value="Other" label="Other">Other</el-option>
                </el-select>
              </div>
            </div>
            <div v-if="showSendReportToOther" class="box-row" >
              <div  class="box-col box-col-left left-label">Send report Email</div>
              <div class="box-col box-col-right">
                <input class="textbox" type="text" placeholder="Send report to this email address" v-model="reportToText" :class="hasError && sendReportEmailError ? 'is-invalid' : ''" />
                <div v-if="hasError && sendReportEmailError" class="text-danger">{{ sendReportEmailError }}</div>
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left left-label">Payment Details</div>
              <div class="box-col box-col-right d-flex align-items-center">
                <img
                  v-if="client.paymentDeferralOption"
                  class="is-icon"
                  src="@/assets/images/payment_deferral_icon.svg"
                  data-toggle="tooltip"
                  data-placement="right"
                  title="Payment deferral"
                  @click="toggleFeeDeferralRequired()"
                  :class="
                    booking.feeDeferralRequired == true
                      ? ''
                      : 'disabled-element'
                  "
                />
                <img
                  class="ml-2"
                  src="@/assets/images/prepayment_required_icon.svg"
                  data-toggle="tooltip"
                  data-placement="right"
                  title="Prepayment required"
                  :class="
                    client.prepaymentRequired == true ? '' : 'disabled-element'
                  "
                />
                <!-- <img class="ml-4" src="@/assets/images/finance_black_icon.svg" @click="togglePaid()" :class="booking.paid == true ? '' : 'disabled-element'" /> -->
                <img
                  class="ml-4 is-icon"
                  src="@/assets/images/specialist_black_icon.svg"
                  @click="toggleSpecialistConfirmedHours()"
                  data-toggle="tooltip"
                  data-placement="right"
                  title="Specialist confirmed hours"
                  :class="
                    booking.specialistConfirmedHours == true
                      ? ''
                      : 'disabled-element'
                  "
                />
              </div>
            </div>
            <div class="box-row">
              <div class="box-col box-col-left left-label">Bill To</div>
              <div class="box-col box-col-right">
                <el-select @change="selectedBillTo" placeholder="Select a Client" class="w-100" v-model="booking.billTo" filterable clearable>
                  <el-option v-for="contact in listBillTo" :key="contact.id" :value="contact.value" :label="contact.name">{{ contact.name }}</el-option>
                  <el-option value="Other" label="Other">Other</el-option>
                </el-select>
              </div>
            </div>
            <div v-if="showBillToEmail" class="box-row">
              <div class="box-col box-col-left left-label">Bill to Email</div>
              <div class="box-col box-col-right">
                <input class="textbox" type="text" placeholder="Bill to this email address" v-model="billToText" :class="hasError && billToEmailError ? 'is-invalid' : ''" />
                <div v-if="hasError && billToEmailError" class="text-danger">{{ billToEmailError }}</div>
              </div>
            </div>
            <div class="box-row" v-for="(hour, index) in booking.bookingHours">
              <div class="box-col box-col-left left-label">
                {{ index == 0 ? "Additional Time" : "" }}
              </div>
              <div class="box-col box-col-right d-flex align-items-center">
                {{ hour.service }}:
                {{
                  hour.numberOfHours +
                  (hour.numberOfHours == 1 ? " Hour" : " Hours")
                }}
                <div>
                  <v-btn class="add-icon add-black-icon" style="background-color: #c4c4c4; color: #6686B6F" @click="openServiceTimeModal"v-if="index == 0">Add New</v-btn>
                </div>
              </div>
            </div>
            <div class="box-row" v-if="booking.bookingHours.length == 0">
              <div class="box-col box-col-left left-label">Additional Time</div>
              <div class="box-col box-col-right d-flex align-items-center">
                <div>
                  <v-btn class="add-icon add-black-icon" style="background-color: #c4c4c4; color: #6686B6F" @click="openServiceTimeModal">Add New</v-btn>
                </div>
              </div>
            </div>
            <AdminAddServiceTimeModal
              ref="adminAddServiceTimeModal"
              :bookingProps="booking"
              :roleProps="roleProps"
              fromProps="create"
            />
            <RequestActionModal ref="requestActionModal" />
          </div>
        </div>
        <div v-if="displayBookingDetails" class="box-row item-right box-col-next">
          <div v-if="displayBookButton"><v-btn dark @click="createBooking()" dark>Book</v-btn></div>
          <div v-else><v-btn dark @click="tapNext()">Next</v-btn></div>
        </div>

        <div class="box" v-if="displayBookingSummery" :key="summaryKey">
          <div class="box-heading col-space-between">
            <div>Booking Summary</div>
          </div>
          <div class="box-body">
            <div class="box-row" v-if="isTPD">
              <div class="box-col box-col-left left-label">Number of services</div>
              <div class="box-col box-col-right">
                <el-checkbox disabled v-model="showMAS" class="default-checkbox tick">MAS</el-checkbox> <el-input-number disabled v-show="showMAS" :controls="false" style="width: 50px" v-model="booking.MAS" controls-position="right" :min="1" step-strictly :max="10"></el-input-number>
                <el-checkbox disabled v-model="showPIC" class="default-checkbox tick">PIC</el-checkbox> <el-input-number disabled v-show="showPIC" :controls="false" style="width: 50px"  v-model="booking.PIC" controls-position="right" :min="1" step-strictly :max="10"></el-input-number>
                <el-checkbox disabled v-model="showSHORT"  class="default-checkbox tick">Short Report</el-checkbox> <el-input-number disabled v-show="showSHORT" :controls="false" style="width: 50px"  v-model="booking.ShortReport" controls-position="right" step-strictly :min="1" :max="10"></el-input-number>
              </div>
            </div>
            <div class="box-row" v-if="!this.hideOtherStatus">
              <div class="box-col box-col-left">Do you need a phone call with the doctor after the appointment? (additional charges may apply)</div>
              <div class="box-col box-col-right">
                <toggle-button @change="onChartToggleChange(7)" :color="{checked: '#56C568', unchecked: '#525252'}" :width="40" :sync="true" :value="booking.callClientAfterAppointment"/>
              </div>
            </div>
            <div class="box-row" v-if="!this.hideOtherStatus && !hideAttendance">
              <div class="box-col box-col-left">Red Health to confirm attendance with Examinee</div>
              <div class="box-col box-col-right">
                <toggle-button @change="onChartToggleChange(8)" :color="{checked: '#56C568', unchecked: '#525252'}" :width="40" :sync="true" :value="booking.redHealthMayContactClaimant"/>
              </div>
            </div>
            <div class="box-row" v-if="this.client.paymentDeferralOption">
              <div class="box-col box-col-left">Is Fee Deferral required?</div>
              <div class="box-col box-col-right">
                <toggle-button @change="onChartToggleChange(9)" :color="{checked: '#56C568', unchecked: '#525252'}" :width="40" :sync="true" :value="booking.feeDeferralRequired"/>
              </div>
            </div>
            <div class="box-row" v-if="this.booking.id">
              <div class="box-col box-col-left">Reason for Reschedule</div>
              <div class="box-col box-col-right">
                  <textarea v-model="reason" placeholder="Enter Reschedule reason" rows="1" maxlength="100" :class="hasError && rescheduleReasonError ? 'is-invalid' : ''"/>
                  <div class="text-danger" v-if="hasError && rescheduleReasonError">
                    {{ rescheduleReasonError }}
                  </div>
              </div>
            </div>
            <div  v-if="booking.bookingTypeId != 6 && booking.bookingTypeId != 8 && !hideWarning" class="box-row box-warning">
              <div class="box-col Warning-left">
                Warning: non-attendance by the claimant may attract a fee.
              </div>
            </div>
          </div>
        </div>
        <div class="box-row item-right" v-if="displayBookingSummery">
          <div style="padding-right:20px"><v-btn  class="btn-light" @click="tapEdit()">Back</v-btn></div>
          <div><v-btn dark @click="createBooking()" dark>Book</v-btn></div>
        </div>

        <div class="alert alert-success hidden-element">
          <a class="close" title="close">×</a>
          <b>Success:</b> {{ successMessage }}
        </div>
        <div class="alert alert-danger hidden-element">
          <a class="close" title="close">×</a>
          <b>Error:</b> {{ errorMessage }}
        </div>

        <div class="box" v-if="displayBookingDetails">
          <div class="box-heading tab">
            <div
              class="tab-heading tab-selected px-5"
              id="heading-notes"
              @click="openTab(0)">Notes</div>
            <div
              class="tab-heading px-5"
              id="heading-files"
              @click="openTab(1)">Files</div>
            <div
                class="tab-heading px-5"
                id="heading-billing"
                @click="openTab(2)">Billing Notes</div>
            <div class="right-element">
              <v-btn class="add-icon" dark @click="openAddNew">Add New</v-btn>
              <AddNoteModal :isBilling="isBilling"
                ref="addNoteModal"
                :bookingProps="booking"
                fromProps="admin"
              />
            </div>
            <div v-if="hasError && notesAndBillingFormatError" class="text-danger w-100 pl-3">{{ notesAndBillingFormatError }}</div>
          </div>
          <div class="box-body tab-content tab-content-boxes hidden-element">
            <div class="box-row overflow-hidden" v-for="(note, index) in booking.bookingNotes" :key="index">
              <div class="box-col">
                {{ note.userName }}
              </div>
              <div class="box-col">{{ formatDate(note.noteDateTime, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm") }}</div>
              <div
                class="box-col"
                data-toggle="tooltip"
                data-placement="right"
                @click="openEditNoteModal(index, note)"
                :title="note.note">
                {{ note.note }}
              </div>
              <div v-if="!note.isHide" class="is-icon right-element" @click="deleteNote(index)">
                <img class="mr-4" v-if="note.internalOnly == 1" src="@/assets/images/eye-private.svg" />
                <img src="@/assets/images/delete_icon.svg" />
              </div>
            </div>
            <div class="box-row" v-for="note in bookingAction">
              <!-- <div class="box-col box-col-left">{{ note.userName }}</div> -->
              <div class="box-col box-col-left">&nbsp;</div>
              <div class="box-col box-col-left">
                {{ formatDate(note.dateRequested, "DD/MM/YYYY hh:mm A") }}
              </div>
              <div
                class="box-col box-col-right box-col-long"
                style="max-width: 60%"
              >
                <strong>Requested Action: </strong>{{ note.requestedAction }}
              </div>
              <div class="is-icon" style="width: 5%">
                <!-- <img src="@/assets/images/delete_icon.svg" @click="deleteNote(note.id)" /> -->
              </div>
            </div>
          </div>

          <div class="box-body tab-content tab-content-boxes hidden-element">
            <div>
              <div>
                <table class="table">
                  <thead>
                    <tr>
                      <th style="width: 15%" class="long-text">File Type</th>
                      <th style="width: 50%" class="long-text">File Name</th>
                      <th style="width: 15%" class="long-text">Uploaded By</th>
                      <th style="width: 10%" class="long-text">Status</th>
                      <th style="width: 10%" class="icon-col">
                        <div class="icon-group">&nbsp;</div>
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div
                class="content-scroll-y"
                style="height: auto; max-height: 460px"
              >
                <table class="table remove-min-height">
                  <tbody :key="fileKey">
                    <tr
                      v-for="(file, index) in booking.bookingFiles"
                      :key="index"
                      class="py-0"
                    >
                      <th style="width: 15%" class="long-text">
                        <select disabled
                          class="textbox"
                          v-model="file.fileTypeId"
                          @change="changeBookingFileType(file, file.fileTypeId)"
                          :class="file.isHide ? 'disabled-element' : ''"
                          :disabled="file.isHide">
                          <option value="" hidden>Select File Type</option>
                          <option
                            v-for="fileType in fileTypes"
                            :value="fileType.FileTypeID">
                            {{ fileType.FileTypeName }}
                          </option>
                        </select>
                        <!-- <span v-else>{{ file.fileTypeName }}</span> -->
                      </th>
                      <th style="width: 50%" class="long-text">
                        <el-tooltip  effect="dark" :content="file.fileName">
                          <span> {{ file.fileName }}</span>
                        </el-tooltip>
                      </th>
                      <th style="width: 15%" class="long-text">
                        {{ file.uploadedByName }}
                      </th>
                      <th style="width: 10%" class="long-text">
                        <select disabled
                          class="textbox"
                          v-model="file.fileStatus"
                          @change="changeBookingFileStatus(file.bookingFileId)"
                          :class="file.isHide ? 'disabled-element' : ''"
                          :disabled="file.isHide">
                          <option value="0">Draft</option>
                          <option value="1">Final</option>
                        </select>
                        <!-- <span v-else>Final</span> -->
                      </th>
                      <th style="width: 10%; vertical-align: middle;" class="icon-col">
                        <div v-if="!file.isHide" class="icon-group d-flex justify-content-center">
                          <img
                            src="@/assets/images/delete_icon.svg"
                            @click="deleteFile(index)"
                          />
                        </div>
                      </th>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="box-col">
              <div
                class="file-upload-area border-gray-300 mt-5 mb-5"
                @dragover="dragover"
                @dragleave="dragleave"
                @drop="drop">
                <input
                  type="file"
                  multiple
                  name="fields[assetsFieldHandle][]"
                  id="assetsFieldHandle"
                  class="w-px h-px opacity-0 overflow-hidden absolute"
                  @change="onChange"
                  ref="file"
                  accept="" />
                <label for="assetsFieldHandle" class="block cursor-pointer d-flex flex-column align-items-center justify-content-center">
                  <div>Drop files in this area or <span style="text-decoration: underline" class="is-icon">click here</span> to upload files.</div>
                  <div>Files over 200MB in file size may cause errors. If you need to upload files of this size, please contact us on 1300 100 733</div>
                </label>
              </div>
            </div>
          </div>

          <div v-if="isBilling"  class="box-body tab-content tab-content-boxes">
            <div class="box-row" v-for="(note, index) in booking.billingNotes" :key="index">
              <div class="box-col">
                {{ note.userName }}
              </div>
              <div class="box-col">{{ formatDate(note.noteDateTime, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm") }}</div>
              <div
                  class="box-col"
                  data-toggle="tooltip"
                  data-placement="right"
                  @click="openEditNoteModal(index, note)"
                  :title="note.note">
                {{ note.note }}
              </div>
              <div v-if="!note.isHide" class="is-icon right-element" @click="deleteNote(index)">
                <img src="@/assets/images/delete_icon.svg" />
              </div>
            </div>
            <div class="box-row" v-for="note in bookingAction">
              <!-- <div class="box-col box-col-left">{{ note.userName }}</div> -->
              <div class="box-col box-col-left">&nbsp;</div>
              <div class="box-col box-col-left">
                {{ formatDate(note.dateRequested, "DD/MM/YYYY hh:mm A") }}
              </div>
              <div
                  class="box-col box-col-right box-col-long"
                  style="max-width: 60%"
              >
                <strong>Requested Action: </strong>{{ note.requestedAction }}
              </div>
              <div class="is-icon" style="width: 5%">
                <!-- <img src="@/assets/images/delete_icon.svg" @click="deleteNote(note.id)" /> -->
              </div>
            </div>
          </div>

          <div class="alert alert-warning confirmation hidden-element">
            <a class="close" title="close" @click="tapButtonConfirmation(false)"
              >×</a
            >
            <b>Warning:</b> Are you sure? Your changes will take effect
            immediately.
            <div class="icon-group">
              <v-btn class="alert-button" @click="tapButtonConfirmation(true)"
              >Yes</v-btn
              >
              <v-btn class="alert-button" @click="tapButtonConfirmation(false)"
              >No</v-btn
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="Add New Contact" width="60%"
               :visible.sync="showContactModal"
               @close="cancelDialog">
      <AdminEditClientContact :clientIdProps="client.id" @contactCreated="contactCreated" />
    </el-dialog>
    <el-dialog  title="Select TimeZone" :visible.sync="showTimeZone">
      <div>
        <el-select filterable v-model="timeZoneValue">
          <el-option v-for="item in timeZones" :key="item" :value="item" :label="item"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
    <v-btn dark class="white-button" @click="cleanData">Cancel</v-btn>
    <el-button type="primary" @click="showTimeZone = false;">OK</el-button>
  </span>
    </el-dialog>
    <TPDFiles :fileCountList="fileCountList" :tpdFilesDialog="tpdFilesDialog" @cancelDialog="tpdFilesDialog = false" @next="handleFiles" />
    <DuplicateCaseModal :dialogVisible="dialogVisible" :hasToChooseCase="hasToChooseCase" @selectCase="selectCase" :result="result" @closeModal="closeModal"/>
    <InterpreterDetailDialog :user="user" ref="interpreterModal"  @clickSave="handleSaveInterpreterDetail"/>
    <SurrogateDetailDialog ref="SurrogateModal"  @clickSave="handleSaveInterpreterDetail"/>
  </div>
</template>

<script>
import utilities from "@/assets/js/utilities";
import AdminNavigation from "@/components/AdminNavigation";
import AdminBookingsMenu from "@/components/AdminBookingsMenu";
import Header from "@/components/Header";
import AddNoteModal from "@/components/AddNoteModal";
import AdminAddServiceTimeModal from "@/components/AdminAddServiceTimeModal";
import AddSpecialistBookingTestModal from "@/components/AddSpecialistBookingTestModal";
import RequestActionModal from "@/components/RequestActionModal";
import ItemTemplate from '@/components/ItemTemplate.vue'
import AddBodyDiagramModal from '@/components/AddBodyDiagramModal'
import AddNameModal from '@/components/AddNameModal'
import AddClientContactModal from '@/components/AddClientContactModal'
import AddClientAddressModal from '@/components/AddClientAddressModal'
import AdminEditClientContact from '@/components/AdminEditClientContact'
import DuplicateCaseModal from '@/components/case/DuplicateCaseModal'
import InterpreterDetailDialog from "@/components/dialog/InterpreterDetailDialog.vue";
import SurrogateDetailDialog from "@/components/dialog/SurrogateDetailDialog.vue";
import business from 'moment-business-days';
import TPDFiles from "./TPDFiles.vue";

export default {
  name: "AdminManageBooking",
  props: ["bookingProps"],
  components: {
    TPDFiles,
    AdminNavigation,
    AdminBookingsMenu,
    Header,
    AddNoteModal,
    AdminAddServiceTimeModal,
    RequestActionModal,
    AddBodyDiagramModal,
    AddNameModal,
    AddClientContactModal,
    AddClientAddressModal,
    DuplicateCaseModal,
    AdminEditClientContact,
    InterpreterDetailDialog,
    SurrogateDetailDialog
  },
  data() {
    return {
      fileCountList: [0, 0, 0, 0],
      tpdFilesDialog: false,
      caseChange: false,
      ShowVideoLinkUrl: false,
      showSHORT: false,
      showMAS: false,
      showPIC: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
      methodKey: 1,
      bookingWithNoAvailability: false,
      deliveryMethods: [],
      bookingExamineeStatus: [],
      timeZones: [],
      timeZoneValue: null,
      showTimeZone: false,
      options: [],
      newCase: null,
      hasToChooseCase: false,
      showLinkLocation: true,
      billToText: '',
      reportToText: '',
      dialogVisible: false,
      result: [],
      curIndex: null,
      salutationList: utilities.initSalutation(),
      isBilling: false,
      itemTemplate: ItemTemplate,
      focused: "",
      focusDropdown: false,
      specialistFocus: false,
      bookingFocus: false,
      locationFocus: false,
      bookingTypeFocus: false,
      attendanceStatusFocus: false,
      paperworkStatusFocus: false,
      sendReportToFocus: false,
      onBehalfOfFocus: false,
      billToFocus: false,
      preApprovedHoursFocus: false,
      hoursForFocus: false,
      hasError: false,
      test: -1,
      showDelivery: false,
      preapprovedHours: [],
      requestedExtraHours: [],

      showSendReportToOther: false,
      showBillToEmail: false,
      listContact: [],
      listBillTo: [],
      originalClientContacts: [],

      overTime: false,
      bodyAreaTag: "",
      otherBodyAreaTag: "",
      personConditionTag: "",
      bodyAreas: [],
      bodyAreaTags: [],
      otherBodyAreaTags: [],
      personConditions: [],
      personConditionTags: [],
      requiresTravel: false,
      videoLinkAvailable: false,
      disableCaseField: false,
      isEditName: true,
      isEditContact: false,
      isEditAddress: false,
      claimFocus: false,
      showClientContact: false,
      addressKey: false,
      nameKey: 0,
      bookingObject: [],
      displayBookingSummery: false,
      displayBookingDetails: true,
      displayBookButton: false,
      summaryKey: 1,
      showBookingStatus: true,
      hideOtherStatus: true,
      hideAttendance: false,
      hideWarning: false,
      showBookingType: false,
      selected: 0,
      values: [
				{ label: 'Confirmed', value: 3, text: 'This will lock in the appointment you have selected' },
				{ label: 'Tentative', value: 2,text: 'This will hold the appointment for you for 24 hours. If you haven\'t confirmed the booking before this time, the appointment will be released, and someone may book that appointment.' },
			],

      specialists: [],
      clients: [],
      specialist: utilities.initSpecialist(),
      client: utilities.initClient(),
      originalListClients: [],
      originalListCases: [],
      originalListLocations: [],
      originalListSpecialists: [],
      listClients: [],
      listCases: [],
      listLocations: [],
      listSpecialists: [],
      item: {},
      cases: [],
      clientCase: utilities.initCase(),
      states: [],
      bookingRequest: [],
      addedBodyArea: [],
      deletedBodyTags: [],
      addedConditions: [],

      filelist: [],
      locations: [],
      clientContacts: [],

      standardFiles: [],
      availableTimes: [],
      minimumAppointment: [],
      bookingStatuses: [],
      bookingTypes: [],
      bookingTypesLocal: utilities.getCreateSpecialistsBookingTypes(),
      claimTypes: [],
      booking: utilities.initBooking(),
      bookingLogs: [],
      availability: [],
      timelineData: [],
      reports: [
        {
          id: 1,
          name: "John",
        },
        {
          id: 2,
          name: "Kate",
        },
      ],
      // deleteId: "",
      deleteIndex: "",
      roleProps: "admin",
      showReassessment: false,
      sendToProps: "",
      showContactModal: false,
      successMessage: "",
      errorMessage: "",
      emails: {},
      bookingAction: [],
      fileTypes: [],
      fileKey: 1,
      users: [],
      disabledDates: {},
      timeSlots: [],
      bookingTime: "",
      reason: "",
    };
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
    isTPD() {
      return this.booking.bookingTypeId === 19
    },
    numOfServicesError() {
      if (this.booking.bookingTypeId !== 19) {
        return ''
      }
      if (!this.showSHORT && !this.showMAS && !this.showPIC) {
        return 'Please select at least one service type (MAS, PIC, or Short Report) and enter a number.'
      }
      if ((this.showSHORT && !this.booking.ShortReport) || (this.showMAS && !this.booking.MAS) || (this.showPIC && !this.booking.PIC)) {
        return 'Please enter a number (1–10) for each selected service type.'
      }
      return ''
    },
    examineeStateError() {
      if (this.booking.DeliveryMethodID !== 2 || this.isTPD) {
        return ''
      }
      if (!this.bookingExamineeStatus || this.bookingExamineeStatus.length === 0 || !this.bookingExamineeStatus[0]) {
        return 'Examinee state is required.'
      }
      return ''
    },
    examineeLocationError() {
      if (this.booking.DeliveryMethodID !== 2) {
        return ''
      }
      return utilities.getExamineeLocationForVideoLinkError(this.booking.ClaimantLocation)
    },
    deliveryMethodError() {
      if (!utilities.bookingTypeWithDeliveryMethods(this.booking.bookingTypeId)) {
        return ''
      }
      if (!this.booking.DeliveryMethodID) {
        return 'Please select a delivery method.'
      }
      return ''
    },
    incidentStateError() {
      if (!this.booking.IncidentState || String(this.booking.IncidentState).trim() === '') {
        return 'State where the incident occurred is required.'
      }
      return ''
    },
    clientReferenceError() {
      if (this.disableCaseField) {
        return ''
      }
      return utilities.getAdminBookingClientReferenceError(this.booking.ClientReference)
    },
    caseOwnerError() {
      if (!this.booking.clientContact) {
        return 'Client contact is required.'
      }
      return ''
    },
    contactDetailsError() {
      if (this.booking.bookingTypeId === 8 || this.booking.bookingTypeId === 6) {
        return ''
      }
      if (this.disableCaseField) {
        return ''
      }
      if (this.booking.claimantConfirmed && !this.booking.claimantEmail && !this.booking.claimantPhone1 && !this.booking.claimantPhone2 && !this.booking.claimantMobile) {
        return 'Contact details are required when attendance is confirmed.'
      }
      return ''
    },
    dateOfBirthError() {
      if (this.disableCaseField) {
        return ''
      }
      const d = this.booking.dateOfBirth
      if (d === '' || d === 'Invalid date' || d === null || d === undefined) {
        return 'Date of birth is required.'
      }
      return ''
    },
    clientIdError() {
      if (!this.bookingObject.isNewCase) {
        return ''
      }
      if (!this.booking.clientId) {
        return 'Client details are required.'
      }
      return ''
    },
    referralTypeError() {
      if (this.isTPD) {
        return ''
      }
      if (!this.booking.claimTypeId) {
        return 'Referral type is required.'
      }
      return ''
    },
    claimantNameErrors() {
      if (this.disableCaseField) {
        return ''
      }
      return [
        utilities.getClientContactPersonNameError(this.booking.claimantFirstName, 'First name'),
        utilities.getClientContactMiddleNameError(this.booking.claimantGivenNames),
        utilities.getClientContactPersonNameError(this.booking.claimantSurname, 'Surname'),
      ].filter(Boolean).join(' ')
    },
    sendReportEmailError() {
      if (!this.showSendReportToOther) {
        return ''
      }
      const s = String(this.reportToText || '').trim()
      if (!s) {
        return 'Send report email is required.'
      }
      return utilities.getClientContactEmailError(this.reportToText, 'Send report email', false)
    },
    billToEmailError() {
      if (!this.showBillToEmail) {
        return ''
      }
      const s = String(this.billToText || '').trim()
      if (!s) {
        return 'Bill to email is required.'
      }
      return utilities.getClientContactEmailError(this.billToText, 'Bill to email', false)
    },
    preferredGivenNameError() {
      if (this.disableCaseField) {
        return ''
      }
      const s = String(this.booking.PreferredGivenName || '').trim()
      if (!s) {
        return ''
      }
      if (s.length > 100) {
        return 'Examinee preferred name must not exceed 100 characters.'
      }
      if (!/(?=.*[A-Za-z])/.test(s)) {
        return 'Examinee preferred name must include at least one English letter when provided.'
      }
      if (!/^[A-Za-z\s'\-]+$/.test(s)) {
        return "Examinee preferred name may only contain English letters, spaces, hyphens (-), and apostrophes (')."
      }
      return ''
    },
    otherBodyAreasError() {
      return utilities.getAdminBookingOtherBodyAreasError(this.otherBodyAreaTags)
    },
    bookingNotesContentError() {
      const list = this.booking.bookingNotes || []
      for (let i = 0; i < list.length; i++) {
        const row = list[i]
        if (row.isHide) {
          continue
        }
        let text = row.note || ''
        try {
          text = decodeURIComponent(text)
        } catch (e) {
          /* keep raw */
        }
        const err = utilities.getBookingRequestNoteError(text)
        if (err) {
          return err
        }
      }
      return ''
    },
    billingNotesContentError() {
      const list = this.booking.billingNotes || []
      for (let i = 0; i < list.length; i++) {
        const row = list[i]
        if (row.isHide) {
          continue
        }
        let text = row.note || ''
        try {
          text = decodeURIComponent(text)
        } catch (e) {
          /* keep raw */
        }
        const err = utilities.getBookingRequestNoteError(text)
        if (err) {
          return err
        }
      }
      return ''
    },
    notesAndBillingFormatError() {
      return [this.bookingNotesContentError, this.billingNotesContentError].filter(Boolean).join(' ')
    },
    rescheduleReasonError() {
      if (!this.booking.id || !this.displayBookingSummery) {
        return ''
      }
      const s = String(this.reason || '').trim()
      if (!s) {
        return 'Please enter the reason for reschedule.'
      }
      return utilities.getAdminBookingAdditionalTimeReasonError(s)
    },

    getAttendanceTitle() {
      var title = "Examinee attendance " + (this.isDate(this.booking.claimantConfirmed) || this.booking.claimantConfirmed ? "" : "not ") + "confirmed"
      return title
    },
    getOTFCETitle() {
      var title = "OTFCE " + (this.booking.otfceRequired ? "" : "not ") + "required"
      return title
    },
    getCanRingClaimantTitle() {
      var title = this.booking.redHealthMayContactClaimant ? "Can ring claimant" : "Can not ring claimant"
      return title
    },
    getConsentReceivedTitle() {
      var title = "Examinee consent " + (this.isDate(this.booking.claimantConsentReceived) || this.booking.claimantConsentReceived ? "" : "not ") + "received"
      return title
    },
    getCallAfterAppointmentTitle() {
      var title = (this.booking.callClientAfterAppointment ? "Phone " : "No ") + "call required"
      return title
    },
    getVideoLinkTestArrangedTitle() {
      var title = "Video link test " + (this.booking.videoLinkTestStatus == 1 || this.booking.videoLinkTestStatus == 2  ? "" : "not ") + "arranged"
      return title
    },
    getHasVideoTitle() {
      var title = "Video link test " + (this.booking.videoLinkTestStatus == 2 ? "" : "not ") + "completed"
      return title
    },

    filteredBodyAreaItems() {
      return this.bodyAreas.filter((i) => {
        return i.text.toLowerCase().indexOf(this.bodyAreaTag.toLowerCase()) !== -1
      })
    },

    filteredPersonConditionsItems() {
      return this.personConditions.filter((i) => {
        return i.text.toLowerCase().indexOf(this.personConditionTag.toLowerCase()) !== -1
      })
    },
    bookingTypeError() {
      if (this.booking.bookingTypeId === '' || this.booking.bookingTypeId === null || this.booking.bookingTypeId === undefined) {
        return 'Service type is required.'
      }
      return ''
    },
  },
  methods: {
    handleFiles(files) {
      this.tpdFilesDialog = false
      this.openTab(1)
      const fileTypes = ['MAS Template', 'PIC Template', 'Letter of Instruction', 'Brief']
      files.forEach((e, i) => {
        e && e.forEach((x) => {
          let file = this.booking.bookingFiles.filter((y) => y.fileName == x.name)
          if (file.length === 0) {
            this.booking.bookingFiles.push({
              fileName: x.name,
              fileTypeId: this.fileTypes.find((x) => x.FileTypeName === fileTypes[i]).FileTypeID,
              uploadedBy: this.user.id,
              mimeType: x.type,
              fileStatus: 1,
              uploadedByName: this.user.name,
              dateUploaded: window.moment().format("YYYY-MM-DD HH:mm:ss"),
              isHide: false,
              file: x
            })
          }
        })
        console.log(this.booking.bookingFiles)
      })
    },
    switchShowLink() {
      this.ShowVideoLinkUrl = !this.ShowVideoLinkUrl
    },
    onChangeNum(name, value) {
      if (value) {
        this.booking[name] = 1
        this.$set(this.booking, name, 1)
      } else {
        this.$set(this.booking, name, 0)
      }
    },
    onSelectMethod(v) {
      this.$set(this.booking, 'DeliveryMethodID', v)
      this.methodKey++;
      this.$forceUpdate()
    },
    getInterpreterDetail() {
      let str = ''

      if(this.booking.InterpreterName) {
        str += '<b>N: </b>' + this.booking.InterpreterName + '&nbsp'
      }
      if(this.booking.InterpreterCompanyName) {
        str += '<b>C: </b>' + this.booking.InterpreterCompanyName + '&nbsp'
      }
      if(this.booking.InterpreterContactNumber) {
        str += '<b>P: </b>' + this.booking.InterpreterContactNumber + '&nbsp'
      }
      if(this.booking.InterpreterContactEmail) {
        str += '<b>E: </b>' + this.booking.InterpreterContactEmail + '&nbsp'
      }
      if(this.booking.InterpreterCost) {
        str += '<b>C: </b>' + this.booking.InterpreterCost + '&nbsp'
      }
      if(str === '') {
        str+= '<span style="color: #D5D5D5">Click to Add Detail</span'
      }
      console.log(str)
      return str
    },
    getSurrogateDetail() {
      let str = ''
      if(this.booking.SurrogateAssessorName) {
        str += '<b>N: </b>' + this.booking.SurrogateAssessorName + '&nbsp'
      }
      if(this.booking.SurrogateAssessorCompanyName) {
        str += '<b>C: </b>' + this.booking.SurrogateAssessorCompanyName + '&nbsp'
      }
      if(this.booking.SurrogateAssessorContactNumber) {
        str += '<b>P: </b>' + this.booking.SurrogateAssessorCompanyName + '&nbsp'
      }
      if(this.booking.SurrogateAssessorContactEmail) {
        str += '<b>E: </b>' + this.booking.SurrogateAssessorContactEmail + '&nbsp'
      }
      if(this.booking.SurrogateAssessorCost) {
        str += '<b>C: </b>' + this.booking.SurrogateAssessorCost + '&nbsp'
      }
      if(str === '') {
        str+= '<span style="color: #D5D5D5">Click to Add Detail</span'
      }
      return str
    },
    cleanData() {
      this.showTimeZone = false;
      this.timeZoneValue = null;
      this.booking.ClaimantCountryDuringBooking = null
      this.booking.ClaimantStateDuringBooking = null
      this.bookingExamineeStatus = []
    },
    onChangeContact(e) {
      this.$set(this.booking, 'clientContact', e)
      this.$forceUpdate()
    },
    async handleChange(e) {
      if (e && e.length > 0) {
        this.booking.ClaimantCountryDuringBooking = e[0]
        this.booking.ClaimantStateDuringBooking = e[1]
        if (e[0] === e[1] && e[1] === "International") {
          await this.$store.dispatch("loading/setLoadComponent", true);
          this.timeZones = await utilities.getTimeZone()
          this.showTimeZone = true
          await this.$store.dispatch("loading/setLoadComponent", false);
        } else {
          this.timeZoneValue = null
        }
        this.$forceUpdate()
      } else {
        this.booking.ClaimantCountryDuringBooking = null
        this.booking.ClaimantStateDuringBooking = null
      }
    },
    async checkReassessments(v) {

      if(!this.booking.bookingDateTime && this.booking.bookingTypeId !== 2 && this.booking.bookingTypeId !== 22) {
        return
      }
      let p = {
        BookingDateTime: this.booking.bookingDateTime,
        SpecialistID: this.booking.specialistId,
        ClaimantFirstName: this.booking.claimantFirstName.trim(),
        ClaimantSurname: this.booking.claimantSurname.trim(),
        ClientID: this.client.id,
        DateofBirth: v ? window.moment(v).format('YYYY-MM-DD') : window.moment(this.booking.dateOfBirth).format('YYYY-MM-DD')
      }
      const result = await utilities.checkReassessments(p)
      this.booking.Reassessment = result.Reassessment
    },
    handleSaveInterpreterDetail(obj) {
      this.booking = {...this.booking, ...obj}
      this.$forceUpdate()
    },
    openInterpreterDetail() {
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterName', this.booking.InterpreterName || '')
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterCompanyName', this.booking.InterpreterCompanyName || '')
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterContactNumber', this.booking.InterpreterContactNumber || '')
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterContactEmail', this.booking.InterpreterContactEmail || '')
      this.$set(this.$refs.interpreterModal.curItem, 'InterpreterCost', this.booking.InterpreterCost || 0)
      this.$refs.interpreterModal.visible = true
    },
    openSurrogateDetail() {
      this.$set(this.$refs.SurrogateModal.curItem, 'SurrogateAssessorName',  this.booking.SurrogateAssessorName || '')
      this.$set(this.$refs.SurrogateModal.curItem, 'SurrogateAssessorCompanyName',  this.booking.SurrogateAssessorCompanyName || '')
      this.$set(this.$refs.SurrogateModal.curItem, 'SurrogateAssessorContactNumber',  this.booking.SurrogateAssessorContactNumber || '')
      this.$set(this.$refs.SurrogateModal.curItem, 'SurrogateAssessorContactEmail',  this.booking.SurrogateAssessorContactEmail || '')
      this.$set(this.$refs.SurrogateModal.curItem, 'SurrogateAssessorCost',  this.booking.SurrogateAssessorCost || 0)
      this.$refs.SurrogateModal.visible = true
    },

    changeBookingFileType(file, typeId) {
    },

    changeBookingFileStatus() {
    },

    contactCreated() {
      this.cancelDialog();
      this.changeClient()
    },
    cancelDialog() {
      this.showContactModal = false
    },
    addNewContact() {
      this.showContactModal = true
    },

    onChangeBookingType() {
      this.checkBookingType()
    },

    getInitials(specialist) {
      var initials = ""
      if (specialist.firstName) {
        initials = specialist.firstName.substring(0,1)
      }

      if (specialist.lastName) {
        initials = initials + specialist.lastName.substring(0,1)
      }
      return initials
    },

    defineClearButton() {
      $(".report-to-selecter input").after("<div class='dropdown-input-clear'></div>")
      $(".report-to-selecter .dropdown-input-clear").click((e) => {
        this.$refs.dropdownEmailSendTo.searchFilter = ""
        this.booking.reportTo = ""
        this.showSendReportToOther = false
      })

      $(".bill-to-selecter input").after("<div class='dropdown-input-clear'></div>")
      $(".bill-to-selecter .dropdown-input-clear").click((e) => {
        this.$refs.dropdownEmailBillTo.searchFilter = ""
        this.booking.billTo = ""
        this.showBillToEmail = false
      })
    },

    setTitle() {
      if (this.displayBookingDetails) {
        if (this.bookingObject.waitlisted && this.bookingObject.caseId == '') {
          return "Create a Waitlist Booking - case Details"
        } else if (this.bookingObject.waitlisted && this.bookingObject.caseId != '') {
          return "Create a Waitlist Booking" + this.getCaseTitle()
        } else {
          if (this.bookingObject.caseId !== '') {
            return "Create a Booking" + this.getCaseTitle()
          } else {
            return "Create a Booking - case Details"
          }
        }
      } else {
        if (this.bookingObject.caseId !== '' && this.bookingObject.waitlisted) {
          return "Waitlist Booking Summary" + this.getCaseTitle()
        } else if (this.bookingObject.waitlisted) {
          return "Waitlist Booking Summary"
        } else if (this.bookingObject.caseId != '') {
          return "Booking Summary" + this.getCaseTitle()
        }  else {
          return "Booking Summary"
        }
      }
    },

    changedBookingStatus(e) {
      if (e == 0) {
        this.selected = 0
        this.booking.bookingStatus = 3
        this.booking.bookingStatusName = "Confirmed"
      } else if (e == 1) {
        this.selected = 1
        this.booking.bookingStatus = 2
        this.booking.bookingStatusName = "Tentative"
      } else {
        this.booking.bookingStatus = 1
        this.booking.bookingStatusName = "Draft"
      }
    },

    tapEdit() {
      var originalBooking = _.cloneDeep(this.booking)
      var originalClient = _.cloneDeep(this.client)
      var showSendReportToOther =  this.showSendReportToOther
      var showBillToEmail = this.showBillToEmail

      this.displayBookingDetails = true
      this.displayBookingSummery = false

      setTimeout(() => {
        this.showSendReportToOther = showSendReportToOther
      }, 100)

      setTimeout(() => {
        this.showBillToEmail = showBillToEmail
      }, 200)

      setTimeout(() => {
        this.booking.reportTo = originalBooking.reportTo
        this.booking.billTo = originalBooking.billTo
        this.booking.clientContact = originalBooking.clientContact
        this.client.id = originalClient.id

        // Reload Client
        var selectedClient = this.originalListClients.find((x) => x.id == this.client.id)
        if (selectedClient && this.$refs.clientDropdown) {
          this.$refs.clientDropdown.selected = selectedClient
          this.$refs.clientDropdown.searchFilter = selectedClient.name
        }


        // Reload Report To
        var sendReportTo = null
        if(!this.showSendReportToOther) {
          sendReportTo = this.listBillTo.find((x) => x.value == this.booking.reportTo)
        } else {
          sendReportTo = this.listBillTo.find((x) => x.id == -1)
          this.reportToText = this.booking.reportTo
        }

        // Reload Bill To
        var billTo = null
        if(!this.showBillToEmail) {
          billTo = this.listBillTo.find((x) => x.value == this.booking.billTo)
        } else {
          billTo = this.listBillTo.find((x) => x.id == -1)
          this.billToText = this.booking.billTo
        }

        this.defineClearButton()
      }, 300)
    },

    setDateInfo() {
      var text = ""
      if (this.booking.bookingTypeId == 7) {
        text = `<b>At:</b> ` + this.formatDate(this.booking.bookingDateTime, "hh:mm A dddd DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss.ssssss")
      } else {
        text = `<b>At:</b> ` + this.formatDate(this.booking.bookingDateTime, "hh:mm A dddd DD/MM/YYYY", "YYYY-MM-DD HH:mm:ss.ssssss") + ' ' + this.getLocationName(this.booking.locationId)
      }
      return text
    },

    openManageAddress() {
      if (!this.disableCaseField) {
        this.$refs.addClientAddressModal.booking = this.booking
        this.$refs.addClientAddressModal.isClient = false
        this.$refs.addClientAddressModal.setBookingAddressDetails()
        this.$refs.addClientAddressModal.handleModal()
      }
    },

    changedClaimantType(event) {
      // this.booking.claimTypeId = event
      this.$set(this.booking, 'claimTypeId', event)
      var item = this.claimTypes.find((x) => x.id == event)
      this.booking.claimTypeName = item.name
      this.$forceUpdate()
    },

    setName(object) {
      this.booking.claimantFirstName = object.firstName
      this.booking.claimantGivenNames = object.middleName
      this.booking.claimantSurname = object.surname
      this.$set(this.booking, 'claimantFullName', utilities.getClaimantFullName(this.booking))
      if (this.booking.claimantFullName) {
        this.isEditName = true
      } else {
        this.isEditName = false
      }
      this.nameKey += 1
      this.checkReassessments()
      this.$forceUpdate()
    },

    getCaseTitle() {
      if (this.clientCase != undefined && this.clientCase.CaseReference != '') {
        return  ' on Case ' + decodeURIComponent(this.bookingObject.caseId) + ' for ' + decodeURIComponent(this.booking.claimantFullName)
      }
      return ''
    },
    changeDate() {
      this.booking.overPeriodofTime = false
    },

    onChartToggleChange(expression) {
      switch (expression) {
        case 4:
        this.booking.overPeriodofTime = !this.booking.overPeriodofTime
          if (this.booking.overPeriodofTime) {
            this.booking.accidentDate = ""
          }
          break;
        case 6:
          this.booking.otfceRequired = !this.booking.otfceRequired
          break;
        case 7:
          this.booking.callClientAfterAppointment = !this.booking.callClientAfterAppointment
          break;
        case 8:
          this.booking.redHealthMayContactClaimant = !this.booking.redHealthMayContactClaimant
          if (!this.booking.redHealthMayContactClaimant) {
            this.hideWarning = false
          } else {
            this.hideWarning = true
          }
          break;
        case 9:
          this.booking.feeDeferralRequired = !this.booking.feeDeferralRequired
          if (!this.booking.feeDeferralRequired && !this.client.paymentDeferralOption) {
            this.displayBanner = true
            this.bannerKey += 1
          } else {
            this.displayBanner = false
          }
          break;

      }
    },

    openAddNameModal() {
      if (!this.disableCaseField) {
        if (this.isEditName) {
          this.$refs.addNameModal.editFullName(this.booking.claimantFirstName, this.booking.claimantGivenNames, this.booking.claimantSurname)
        }
        this.$refs.addNameModal.handleModal();
      }
    },

    openManageContactDetails() {
      if (!this.disableCaseField) {
        this.$refs.addClientContactModal.singleCase = this.singleCase
        this.$refs.addClientContactModal.booking = this.booking
        this.$refs.addClientContactModal.setBookingContactDetails()
        this.$refs.addClientContactModal.handleModal()
      }
    },

    getShortLocationName() {
      if (this.booking.locationId && this.locations.length > 0) {
        return this.locations.find((x) => x.id == this.booking.locationId).shortLocation
      }
      return ""
    },

    getSpecialistInfo(locationId, locations) {
      var text = ""
      if (this.specialist.qualificationList) {
        text = this.specialist.qualificationList
        return text
      }

      // if (locationId) {
      //   var value = locations.find((x) => x.id == locationId).shortLocation
      //   if (value) {
      //     return text + ", " + value
      //   }
      // }
      return ""
    },

    getBookingTypeById(typeId) {
      if (typeId) {
        var type = this.bookingTypes.find((x) => x.id == typeId)
        if (type) {
          return type.name
        }
      }
      return ""
    },

    openDigram() {
      this.openBodyDiagram()
    },

    openBodyDiagram() {
      this.$refs.addBodyDiagramModal.handleModal()
      this.$refs.addBodyDiagramModal.filteredBodyAreas = this.bodyAreas
      this.$refs.addBodyDiagramModal.bodyAreas = _.cloneDeep(this.bodyAreaTags)
      this.$refs.addBodyDiagramModal.handleClick()
    },

    setBodyArea(addedBodyAreas) {
      this.bodyAreaTags = []
      this.bodyAreaTags = addedBodyAreas
    },

    deleteBodyAreaItems(items) {
      items.map((x) => {
        this.deletedBodyTags.push(x.tag)
      })
    },

    updateConditions(newTags) { //removed it from case
      if(this.$refs.conditions.newTag.length == 0) newTags.pop()
      this.personConditionTags = newTags
    },


    selectedSendTo(item) {
      if (item === 'Other') {
        this.showSendReportToOther = true
          this.reportToText = ""
      } else {
        this.showSendReportToOther = false
      }
    },

    selectedBillTo(item) {
      if (item === 'Other') {
        this.showBillToEmail = true
        this.billToText = ""
      } else {
        this.showBillToEmail = false
      }
    },


    openTab(index) {
      if(index === 2) {
        this.isBilling = true
      } else {
        this.isBilling = false
      }
      utilities.openTab(index)
    },
    openAddNew() {
      if($(".tab-content").eq(1).is(":visible")) this.openAddFile()
      else this.openAddNoteModal()
    },
    openAddNoteModal() {
      this.curIndex = null
      this.$refs.addNoteModal.addNewNote()
      this.$refs.addNoteModal.isNewNote = true
      this.$refs.addNoteModal.handleModal()
    },
    openEditNoteModal(index, noteObj) {
      this.$refs.addNoteModal.internalOnly = noteObj.internalOnly
      this.$refs.addNoteModal.isNewNote = false
      this.$refs.addNoteModal.editCurrentNote(noteObj.note, true)
      this.$refs.addNoteModal.handleModal()
      this.curIndex = index
    },
    adminEditNoteToBooking(notes) {
      const obj = {
        note: notes,
        noteDateTime: moment().format('YYYY-MM-DD HH:mm:ss'),
        userName: this.user.name,
      }
      if(this.isBilling) {
        this.$set(this.booking.billingNotes, this.curIndex, obj)
      } else {
        obj.internalOnly = this.$refs.addNoteModal.internalOnly
        this.$set(this.booking.bookingNotes, this.curIndex, obj)
      }
    },
    openAddFile() {
      $('#assetsFieldHandle').trigger('click')
    },
    changeLocation() {
      if(this.specialist.id != '') {
        //this.getSpecialistAvailability()
      }
    },

    onChange() {
      this.filelist = [...this.filelist, ...this.$refs.file.files]
      //this.booking.bookingFiles = []
      var i = 0
      this.filelist.map((x) => {
        if (x.index == undefined) {
          x.index = i
        }
        var file = this.booking.bookingFiles.filter((y) => y.index == x.index)
        if (file == 0) {
          this.booking.bookingFiles.push({
            fileName: x.name,
            fileTypeId: this.fileTypes.find((x) => x.FileTypeName == 'Internal Document').FileTypeID,
            uploadedBy: this.user.id,
            mimeType: x.type,
            fileStatus: 1,
            uploadedByName: this.user.name,
            dateUploaded: moment().format("YYYY-MM-DD HH:mm:ss"),
            isHide: false,
            index: i,
            file: x
          })
        }
        this.fileKey += 1
        i = i + 1
      })
    },

    checkBookingType() {
      this.showDelivery = utilities.bookingTypeWithDeliveryMethods(this.booking.bookingTypeId)
    },

    deleteFile(index) {
      this.filelist.splice(index, 1)
      this.booking.bookingFiles.splice(index, 1)
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains('bg-green-300')) {
      //   event.currentTarget.classList.remove('bg-gray-100')
      //   event.currentTarget.classList.add('bg-green-300')
      // }
      event.currentTarget.classList.add("dark-border-hover");
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add('bg-gray-100')
      // event.currentTarget.classList.remove('bg-green-300')
      event.currentTarget.classList.remove("dark-border-hover");
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray-100");
      event.currentTarget.classList.remove("bg-green-300");
      event.currentTarget.classList.remove("dark-border-hover");
    },

    async loadData() {
     if (!this.bookingObject.isNewCase) { // Existing case
       this.clientCase = await utilities.getCaseByCaseId(this.bookingObject.caseId);
       if (this.clientCase) {
         this.disableCaseField = false
         this.booking.claimantFullName = this.clientCase.ClaimantFullName
         this.booking.dateOfBirth = this.clientCase.DateofBirth
         this.booking.claimTypeID = this.clientCase.ClaimTypeID
         this.booking.claimantFirstName = this.clientCase.ClaimantFirstName
         this.booking.claimantSurname = this.clientCase.ClaimantSurname

         this.booking.claimantPhone1 = this.clientCase.ClaimantPhone1
         this.booking.claimantMobile = this.clientCase.ClaimantMobile
         this.booking.claimantPhone2 = this.clientCase.ClaimantPhone2
         this.booking.claimantEmail = this.clientCase.ClaimantEmail

         if(this.bookingObject.isSupplementary) {
           let address = ''
           if (this.clientCase.ClaimantAddressLine1) {
             address += this.clientCase.ClaimantAddressLine1 + ', '
             this.booking.claimantAddressLine1 = this.clientCase.ClaimantAddressLine1
           }
           if (this.clientCase.ClaimantAddressLine2) {
             address += this.clientCase.ClaimantAddressLine2 + ', '
             this.booking.claimantAddressLine2 = this.clientCase.ClaimantAddressLine2
           }
           if (this.clientCase.ClaimantCity) {
             address += this.clientCase.ClaimantCity + ', '
             this.booking.claimantCity = this.clientCase.ClaimantCity
           }
           if (this.clientCase.ClaimantState) {
             address += this.clientCase.ClaimantState + ' '
             this.booking.claimantState = this.clientCase.ClaimantState
           }
           if (this.clientCase.ClaimantPostcode) {
             address += this.clientCase.ClaimantPostcode
             this.booking.claimantPostcode = this.clientCase.ClaimantPostcode
           }
           this.booking.claimantFullAddress = address
           this.booking.onBehalfOf = this.bookingObject.OnBehalfOf
           this.booking.overPeriodofTime = this.bookingObject.OverPeriodofTime
           this.booking.accidentDate = this.bookingObject.AccidentDate
           this.bodyAreaTags = utilities.getAutoCompleteBodyAreaTags(this.bookingObject.bodyAreaTags)
           this.otherBodyAreaTags = this.bookingObject.otherBodyAreaTags || []
           this.booking.PersonConditions = this.bookingObject.PersonConditions
           this.isEditAddress = true
           console.log(this.booking)
         }

         if (this.booking.claimantPhone1 !== '' || this.booking.claimantMobile !== '' || this.booking.claimantPhone2 !== '' || this.booking.claimantEmail !== '') {
           this.isEditContact = true
         } else {
           this.isEditContact = false
         }
       }
     } else { // New case
       this.clientCase.ClientID = this.bookingObject.clientId
       this.disableCaseField = false
     }
      this.client = {id: this.bookingObject.clientId, ClientName: this.bookingObject.ClientName}
      if (this.client && this.client.redHealthMayContactClaimants) {
        this.hideAttendance = false
        this.hideWarning = true
        this.booking.redHealthMayContactClaimant = true
      } else {
        this.hideWarning = false
        this.hideAttendance = true
      }

      this.clientContacts = this.bookingObject.originalClientContacts
      this.listBillTo =  this.clientContacts
      await this.$store.dispatch("loading/setLoadComponent", true);

      const apiArray = [utilities.getSpecialistById(this.bookingObject.id), utilities.getLocations(), utilities.getBodyArea(), utilities.getPersonConditions(), utilities.getBookingTypes(), utilities.getClaimTypes(), utilities.getFileTypes(), utilities.getStateCodes(), utilities.getClients(),]
      const r = await Promise.all(apiArray)
      this.specialist = r[0]
      this.locations = r[1]
      var bodyAreas = r[2]
      var personConditions = r[3]
      this.bookingTypes = r[4];
      this.claimTypes = r[5];
      this.options = r[7];
      this.clients = r[8];
      this.fileTypes = r[6]

      if(this.booking.claimTypeID) {
        const name = this.claimTypes.find((x) => x.id === this.clientCase.ClaimTypeID)
        this.booking.claimTypeName = name?.name
      }

      this.clients.sort((a, b) => {
        return a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1;
      });

      this.originalListClients = _.cloneDeep(utilities.getDropdownAutoCompleteTag(this.clients))
      if (this.bookingObject.isNewCase) {
        this.listClients = this.originalListClients
      }


      this.states = utilities.getStates()
      // this.originalListLocations = _.cloneDeep(utilities.getDropdownLocation(this.locations))
      // this.listLocations =  this.originalListLocations


      this.bodyAreas = utilities.getAutoCompleteBodyAreaTags(bodyAreas)

      this.personConditions = utilities.getAutoCompleteTagsUpperCase(personConditions)


      this.booking.bookingHours = [];
      this.booking.bookingTests = [];
      this.getTimelineData();

      this.disabledDates = {
        ranges: [
          {
            from: moment(utilities.START_DATE, "YYYY-MM-DD"),
            to: moment().subtract(1, 'd'),
          },
          {
            from: moment(),
          }
        ],
      }

      await this.$store.dispatch("loading/setLoadComponent", false);
    },
    getTimelineData() {
      var timeline = {};
      this.bookingLogs.map((x) => {
        timeline = {
          id: x.bookingLogId,
          userName: x.userName,
          datetime: utilities.formatDate(x.logDate, "DD/MM/YYYY hh:ss A", "YYYY-MM-DD HH:mm:ss.ssssss"),
          body: x.logDetails,
        };
        this.timelineData.push(timeline);
      });
    },
    async updateFileType(bookingFileId) {
      this.$store.dispatch("loading/setLoadComponent", true);
      this.booking.bookingFiles.map((x) => {
        if (x.bookingFileId === bookingFileId) {
          x.fileTypeName = this.fileTypes.find(
            (y) => y.id == x.fileTypeId
          ).name;
        }
      });
      var params = {
        BookingFileID: bookingFileId,
        FileTypeID: this.booking.bookingFiles.find(
          (x) => x.bookingFileId === bookingFileId
        ).fileTypeId,
        UserID: this.user.id,
        Username: this.user.name,
      };
      await utilities.putBookingFileDetails(params);
      this.$store.dispatch("loading/setLoadComponent", false);
    },
    async finalizeFile(bookingFileId) {
      this.$store.dispatch("loading/setLoadComponent", true);
      var params = {
        BookingFileID: bookingFileId,
        FileStatus: 1,
        UserID: this.user.id,
        Username: this.user.name,
      };
      await utilities.putBookingFileDetails(params);
      this.$store.dispatch("loading/setLoadComponent", false);
    },
    getUploadedByName(id) {
      var user = this.users.find((x) => x != undefined && x.id === id);
      return user === undefined ? "" : user.name;
    },
    formatDate(dateToFormat, newFormat = "YYYY-MM-DD", currentFormat = "YYYY-MM-DD") {
      return utilities.formatDate(dateToFormat, newFormat, currentFormat)
    },
    getBookingType(id) {
      var bookingType = this.bookingTypes.find(x => x.id == id)
      return bookingType != undefined ? bookingType.name : ''
    },
    toggleCallAfterAppointment() {
      utilities.disposeTooltip()
      this.booking.callClientAfterAppointment = !this.booking.callClientAfterAppointment
      utilities.initTooltip()
    },
    toggleCanRingClaimant() {
      utilities.disposeTooltip()
      this.booking.redHealthMayContactClaimant = !this.booking.redHealthMayContactClaimant
      utilities.initTooltip()
    },
    toggleAttendance() {
      utilities.disposeTooltip()
      this.booking.claimantConfirmed = !this.booking.claimantConfirmed
      utilities.initTooltip()
    },
    toggleConsentReceived() {
      utilities.disposeTooltip()
      this.booking.claimantConsentReceived = !this.booking.claimantConsentReceived
      utilities.initTooltip()
    },

    toggleVideoLinkTestArranged() {
      if (this.booking.videoLinkTestStatus == 2) {
        return
      }
      utilities.disposeTooltip()
      if (this.booking.videoLinkTestStatus == '') {
        this.booking.videoLinkTestStatus = 1
      } else {
        this.booking.videoLinkTestStatus = ''
      }
    },
    toggleHasVideo() {
      utilities.disposeTooltip()
      this.booking.hasVideoLink = !this.booking.hasVideoLink
      utilities.initTooltip()
    },
    toggleFeeDeferralRequired() {
      utilities.disposeTooltip()
      this.booking.feeDeferralRequired = !this.booking.feeDeferralRequired
      utilities.initTooltip()
    },
    toggleSpecialistConfirmedHours() {
      utilities.disposeTooltip()
      this.booking.specialistConfirmedHours = !this.booking.specialistConfirmedHours
      utilities.initTooltip()
    },
    openServiceTimeModalPreApproved() {
      this.roleProps = ""
      this.$refs.adminAddServiceTimeModal.handleModal()
    },
    openServiceTimeModal() {
      this.roleProps = "adminAsSpecialist"
      this.$refs.adminAddServiceTimeModal.handleModal()
    },
    deleteNote(index) {
      utilities.showAlert(".confirmation", false)
      this.deleteIndex = index
    },
    tapButtonConfirmation(states) {
      utilities.hideAlert(".confirmation")
      if (states) {
        this.isBilling ? this.booking.billingNotes.splice(this.deleteIndex, 1) : this.booking.bookingNotes.splice(this.deleteIndex, 1)
      }
    },

    openTestsModal(e) {
      e.preventDefault()
      e.stopPropagation()
      this.$refs.addSpecialistBookingTestModal.selectedIndex = -1
      this.$refs.addSpecialistBookingTestModal.test = this.test
      this.$refs.addSpecialistBookingTestModal.handleModal()
    },

    setTestAndOpenModal(e, test, index) {
      e.preventDefault()
      e.stopPropagation()
      this.$refs.addSpecialistBookingTestModal.selectedIndex = index
      this.$refs.addSpecialistBookingTestModal.test = test
      this.$refs.addSpecialistBookingTestModal.handleModal()
    },

    getLocationName(id) {
      if (id) {
        return this.locations.find((x) => x.id == id).fullLocation.replace(', Australia', "")
      }
    },

    getLocationState(id) {
      if (id) {
        return this.locations.find((x) => x.id == id).state
      }
    },

    getClaimantTypeName(id) {
      var type = ''
      if (id) {
        type = this.claimTypes.find((x) => x.id == id).name
      }
      return type
    },

    showBookingConfirmation() {
      //If type is File Review
      this.showBookingStatus = true
      this.hideOtherStatus = false
      if (this.booking.bookingTypeId == 6) {
        this.showBookingStatus = false
        this.hideOtherStatus = true
      }

      //If type is phone call
      if (this.booking.bookingTypeId == 7) {
        this.showBookingStatus = true
        this.hideOtherStatus = true
      }

      if (this.bookingObject.waitlisted || this.booking.bookingTypeId == 14 || this.booking.bookingTypeId == 15 ) {
        this.showBookingStatus = false
        this.hideOtherStatus = true
      }

      this.booking.bookingStatus = 3
      this.booking.bookingStatusName = "Confirmed"
      this.displayBookingDetails = false
      this.displayBookingSummery = true
    },

    checkValidFilesForTPD() {
      const fileTypes = ['MAS Template', 'PIC Template', 'Letter of Instruction', 'Brief']
      const fileCounts = [this.showMAS ? this.booking.MAS : 0, this.showPIC ?this.booking.PIC : 0, this.showSHORT ? this.booking.ShortReport : 0, 1]
      console.log(fileCounts)
      let valid = true
      fileTypes.forEach((file, i) => {
        const id = this.fileTypes.find((x) => x.FileTypeName === file).FileTypeID
        const filter = this.booking.bookingFiles.filter(x => x.fileTypeId === id)
        if(filter.length < fileCounts[i] && file !== 'Brief') {
          this.fileCountList[i] = fileCounts[i] - filter.length
          valid = false
        } else if (file === 'Brief' && filter.length === 0) {
          this.fileCountList[i] = 1
          valid = false
        } else {
          this.fileCountList[i] = 0
        }
      })
      return valid
    },

    sanitizeCreateBookingForm() {
      if (this.booking.ClientReference != null) {
        this.booking.ClientReference = String(this.booking.ClientReference).trim()
      }
      if (this.booking.PreferredGivenName != null && typeof this.booking.PreferredGivenName === 'string') {
        this.booking.PreferredGivenName = this.booking.PreferredGivenName.trim()
      }
      this.booking.claimantFirstName = String(this.booking.claimantFirstName || '').trim()
      this.booking.claimantGivenNames = String(this.booking.claimantGivenNames || '').trim()
      this.booking.claimantSurname = String(this.booking.claimantSurname || '').trim()
      this.reportToText = String(this.reportToText || '').trim()
      this.billToText = String(this.billToText || '').trim()
      this.reason = String(this.reason || '').trim()
    },
    trimBookingField(key) {
      const v = this.booking[key]
      if (v === undefined || v === null || typeof v !== 'string') {
        return
      }
      this.booking[key] = v.trim()
    },
    collectBookingValidationErrors(includeRescheduleReason) {
      const errs = [
        this.clientIdError,
        this.caseOwnerError,
        this.bookingTypeError,
        this.deliveryMethodError,
        this.incidentStateError,
        this.numOfServicesError,
        this.claimantNameErrors,
        this.clientReferenceError,
        this.dateOfBirthError,
        this.contactDetailsError,
        this.examineeStateError,
        this.examineeLocationError,
        this.referralTypeError,
        this.preferredGivenNameError,
        this.sendReportEmailError,
        this.billToEmailError,
        this.otherBodyAreasError,
        this.bookingNotesContentError,
        this.billingNotesContentError,
      ]
      if (includeRescheduleReason) {
        errs.push(this.rescheduleReasonError)
      }
      return errs.filter(Boolean)
    },
    async tapNext() {
      this.sanitizeCreateBookingForm()
      const validationErrors = this.collectBookingValidationErrors(false)
      if (validationErrors.length > 0) {
        this.hasError = true
        this.errorMessage = "Please correct the errors shown above and try again."
        utilities.showAlert(".alert-danger")
        return false
      }
      if(this.isTPD && !this.checkValidFilesForTPD()) {
        this.$forceUpdate()
        console.log(this.fileCountList)
        this.tpdFilesDialog = true
        return
      }

      this.showBookingConfirmation()
      this.summaryKey += 1
      this.hasError = false
      setTimeout(() => {
        utilities.initTooltip()
      }, 300)
    },

    async getDuplicateCase() {
      this.hasToChooseCase = false
      if (!this.clientCase.id) {
        const param = {
          ClaimantFirstName: this.booking.claimantFirstName,
          ClaimantSurname: this.booking.claimantSurname,
          DateofBirth: this.booking.dateOfBirth,
          ClientID: this.booking.clientId
        }
        this.$store.dispatch("loading/setLoadComponent", true)
        const {clientCase, total} = await utilities.getCasesDuplicate(param)
        const duplicateCase = clientCase.find(item => (item.claimantFirstName === this.booking.claimantFirstName && item.claimantSurname === this.booking.claimantSurname && window.moment(item.dateOfBirth).isSame(window.moment(this.booking.dateOfBirth))))
        if(duplicateCase) this.hasToChooseCase = true
        if (total > 0) {
          this.result = clientCase
          this.dialogVisible = true
        }
        this.$store.dispatch("loading/setLoadComponent", false)
      }
    },
    selectCase(item) {
      this.dialogVisible = false
      if(item) {
        this.clientCase = item
        this.bookingObject.isNewCase = false
        this.caseChange = true
      }
      this.createBooking(true)
    },
    closeModal() {
      this.result = []
      this.dialogVisible = false
      if(this.displayBookingSummery) this.tapEdit()
    },

    async createBooking(canCreate) {
      this.sanitizeCreateBookingForm()
      const validationErrors = this.collectBookingValidationErrors(this.displayBookingSummery)
      if (validationErrors.length > 0) {
        this.hasError = true
        this.errorMessage = "Please correct the errors shown above and try again."
        utilities.showAlert(".alert-danger")
        return false
      }
      this.hasError = false
      if(!canCreate && this.bookingObject.isNewCase) {
        await this.getDuplicateCase()
        if(this.dialogVisible) return
      }
      await this.$store.dispatch("loading/setLoadComponent", true)
      if(this.booking.specialistAvailabilityId) {
        const available = await utilities.getSpecialistAvailabilities(this.booking.specialistId, '', {AvailabilityID: this.booking.specialistAvailabilityId})
        if(available[0] && available[0].Availabilities) {
          const single = available[0].Availabilities.find(item => this.booking.specialistAvailabilityId === item.AvailabilityID)
          console.log(single)
          if(single && (single.AvailabilityStatus !== '2' || single.BookingStatus !== 'A')) {
            if(!this.bookingObject.tentativeBookingID || (this.bookingObject.tentativeBookingID && single.BookingStatus !== 'H')) {
              this.errorMessage = "Booking Time not available now, please go back to select another availability"
              utilities.showAlert(".alert-danger")
              await this.$store.dispatch("loading/setLoadComponent", false)
              return
            }
          } else if (single && single?.Location && single?.Location?.LocationID !== this.booking.locationId) {
            this.$msgbox({
              message: `The address for this availability has been updated to ${this.getLocationName(single.Location.LocationID)}. Please click “Confirm” to book the appointment with this new address, or "Cancel" to pick a different availability`,
              title: 'Warning',
              showCancelButton: true,
              confirmButtonText: 'Confirm',
              cancelButtonText: 'Cancel',
            }).then(() => {
              this.booking.locationId = single.Location.LocationID
              this.createBooking(true)
            }).catch(() => {
              this.$router.replace('/admin-search-specialist')
            });
            await this.$store.dispatch("loading/setLoadComponent", false)
            return
          }
        }
      }
      var bodyAreaObjects = []
      var bodyArea = {}
      if (this.bodyAreaTags.length > 0) {
        this.bodyAreaTags.map((x) => {
          var temp = this.addedBodyArea.filter((y) => y.bodyArea == x.text)[0]
          if (temp == undefined) {
              bodyArea = {
                BodyAreaID: x.value
              }
              bodyAreaObjects.push(bodyArea)
          }
        })
      }

      var otherBodyArea = ""
      console.log(this.otherBodyAreaTags)
      this.otherBodyAreaTags.map((x) => {
        if (otherBodyArea == "") {
          otherBodyArea = x.text
        } else {
          otherBodyArea = otherBodyArea + "," + x.text
        }
      })

      if (this.bookingObject.waitlisted) {
        this.booking.bookingStatus = 16
      } else {
        if (this.booking.bookingStatus == '' || this.booking.bookingStatus == 0) {
          this.booking.bookingStatus = 1
        }
      }

      var params = {
        Booking: {
          MAS: this.showMAS ? this.booking.MAS : 0,
          PIC: this.showPIC ? this.booking.PIC : 0,
          ShortReport: this.showSHORT ? this.booking.ShortReport : 0,
          DeliveryMethodID: this.booking.DeliveryMethodID,
          // VideoLinkURL: this.booking.VideoLinkURL,
          ClaimantCountryDuringBooking: this.booking.ClaimantCountryDuringBooking,
          IncidentState: this.booking.IncidentState,
          ClientID: this.client.id,
          Reassessment: this.booking.Reassessment ? 1 : 0,
          SpecialistID: this.specialist.id,
          BookingStatus: JSON.stringify(this.booking.bookingStatus),
          ClientReference: this.booking.ClientReference,
          BookingTypeID: this.booking.bookingTypeId,
          ClaimantLocation: this.booking.ClaimantLocation || '',
          AvailabilityID: this.booking.specialistAvailabilityId,
          RedHealthMayContactClaimant: utilities.convertNumToBool(this.booking.redHealthMayContactClaimant),
          SpecialistConfirmedHours: this.booking.specialistConfirmedHours,
          OnBehalfOf: this.booking.onBehalfOf,
          BillTo: this.showBillToEmail ? this.billToText : this.booking.billTo,
          ReportTo: this.showSendReportToOther ? this.reportToText : this.booking.reportTo,
          VideoLink: this.booking.DeliveryMethodID === 2,
          VideoLinkTestStatus: this.booking.videoLinkTestStatus,
          BookingDateTime: this.booking.bookingDateTime,
          SurrogateRequired: false,
          SurrogateAssessorName: this.booking.SurrogateAssessorName,
          SurrogateAssessorCompanyName: this.booking.SurrogateAssessorCompanyName,
          SurrogateAssessorContactNumber: this.booking.SurrogateAssessorContactNumber,
          SurrogateAssessorContactEmail: this.booking.SurrogateAssessorContactEmail,
          SurrogateAssessorCost: this.booking.SurrogateAssessorCost ? Number(this.booking.SurrogateAssessorCost) : null,
          InterpreterRequired: false,
          VideoLinkURL: this.booking.VideoLinkURL,
          InterpreterName: this.booking.InterpreterName,
          InterpreterCompanyName: this.booking.InterpreterCompanyName,
          InterpreterContactNumber: this.booking.InterpreterContactNumber,
          InterpreterContactEmail: this.booking.InterpreterContactEmail,
          InterpreterCost: this.booking.InterpreterCost ? Number(this.booking.InterpreterCost): null,
          CallClientAfterAppointment: this.booking.callClientAfterAppointment,
          FeeDeferralRequired: this.booking.feeDeferralRequired,
          OverPeriodofTime: this.booking.overPeriodofTime ? 1 : 0,
          AccidentDate: (this.booking.accidentDate && window.moment(this.booking.accidentDate).isValid()) ? window.moment(this.booking.accidentDate, "YYYY-MM-DD").format('YYYY-MM-DD') : "",
          BodyAreaOther: otherBodyArea,
          ClaimTypeID: this.booking.claimTypeId,
          ClientContactID: this.booking.clientContact,
          BookingEndTime:  this.booking.bookingEndTime ? window.moment(this.booking.bookingEndTime, 'HH:mm:ss').format('HH:mm:ss') : '',
        },

        BodyAreas: bodyAreaObjects,
        PersonConditions: this.booking.PersonConditions.map(item => {return {PersonConditionID: item}}),
        BookingNotes: this.booking.bookingNotes.map((x) => {
          return { Note: x.note,  InternalOnly: x.internalOnly ? x.internalOnly : 0, UserID: x.userId, UserName: x.userName };
        }),
        BillingNotes: this.booking.billingNotes.map((x) => {
          return { Note: x.note };
        }),
        BookingHours: this.booking.bookingHours
          .map((x) => {
            return {
              Service: x.service,
              NumberHours: x.numberOfHours,
              BookingHoursStatus: 0,
              RequestedBy: this.specialist.id,
              DateRequested: moment().format('YYYY-MM-DD')
            };
          })
      }

      if(this.booking.bookingTypeId === 19 || this.booking.bookingTypeId === 8 || this.booking.bookingTypeId === 21 || this.booking.bookingTypeId === 18 || this.booking.bookingTypeId === 6 ) {
        params.Booking.PaperworkProcessed = moment().format('YYYY-MM-DD HH:mm:ss')
      }
      if(this.bookingObject.redReschedule && this.bookingObject.bookingId) {
        params.RedRescheduled = {
          CancelledBookingID: this.bookingObject.bookingId
        }
      }

      // phone call
      if(this.booking.bookingTypeId === 7) {
        params.Booking.ShowVideoLinkUrl = this.ShowVideoLinkUrl ? 1: 0
      }

      if(this.booking.bookingTypeId === 8) {
        params.Booking.SuppFutureDate = window.moment(this.booking.SuppFutureDate).format('YYYY-MM-DD HH:mm:ss')
      }

      if(this.clientCase.id) {
        params.Booking.CaseID = this.clientCase.id
      }

      if(this.bookingObject.tentativeBookingID) {
        params.TentativePreBookingID = this.bookingObject.tentativeBookingID
      }

      if(this.bookingObject.WaitListPreBookingID) {
        params.WaitListPreBookingID = this.bookingObject.WaitListPreBookingID
      }

      if(this.booking.locationId) {
        params.Booking.LocationID = this.booking.locationId
      }

      // 4202 - Appointments by Video – Handling Location & Links
      if(this.booking.ClaimantStateDuringBooking && this.booking.ClaimantCountryDuringBooking && !this.isTPD) {
        params.Booking.ClaimantStateDuringBooking =this.booking.ClaimantStateDuringBooking
        params.Booking.ClaimantCountryDuringBooking =this.booking.ClaimantCountryDuringBooking
        params.Booking.ClaimantTimeZoneDuringBooking = this.timeZoneValue
      }

      var cb = async (res, caseId) => {
        this.booking.id = res
        this.booking.CaseID = caseId
      }

      if (this.booking.claimantConfirmed == true) {
        params.Booking.ClaimantConfirmed = moment().format("YYYY-MM-DD HH:mm:ss")
      }

      if (this.booking.claimantConsentReceived == true) {
        params.Booking.ClaimantConsentReceived = moment().format("YYYY-MM-DD HH:mm:ss")
      }

      if (this.booking.paperworkDue) {
        params.Booking.PaperworkDue = moment(this.booking.paperworkDue, "DD/MM/YYYY").format("YYYY-MM-DD")
      }

      //Pass this only convert Supplementary service into the booking
      if (this.bookingRequest && this.bookingRequest.originalBookingId) {
        params.Booking.OriginalBookingID = this.bookingRequest.originalBookingId
      } else if (this.bookingObject.bookingId) {
        params.Booking.OriginalBookingID = this.bookingObject.bookingId
      }


      if (this.bookingObject.isNewCase) {
        params.Booking.CaseID = 0
        params.Case = {}
        params.Case.ClientID = this.client.id
        params.Case.ClaimantFirstName = this.booking.claimantFirstName.trim()
        params.Case.ClaimantGivenNames = this.booking.claimantGivenNames
        params.Case.ClaimantSurname = this.booking.claimantSurname.trim()
        params.Case.DateofBirth = moment(this.booking.dateOfBirth, "YYYY-MM-DD").format('YYYY-MM-DD')
        params.Case.Salutation = this.booking.Salutation
        params.Case.PreferredGivenName = this.booking.PreferredGivenName
        params.Case.ClaimantPhone1 = utilities.validatePhonenumber(this.booking.claimantPhone1)
        params.Case.ClaimantPhone2 = utilities.validatePhonenumber(this.booking.claimantPhone2)
        params.Case.ClaimantMobile = utilities.updateMobileCode(utilities.validatePhonenumber(this.booking.claimantMobile))
        params.Case.ClaimantEmail = this.booking.claimantEmail ? decodeURIComponent(this.booking.claimantEmail) : undefined
        params.Case.ClaimantAddressLine1 = decodeURIComponent(this.booking.claimantAddressLine1)
        params.Case.ClaimantAddressLine2 = decodeURIComponent(this.booking.claimantAddressLine2)
        params.Case.ClaimantCity = this.booking.claimantCity
        params.Case.ClaimantState = this.booking.claimantState
        params.Case.ClaimantPostcode = this.booking.claimantPostcode
        params.Case.ClaimantCountry = 'AU'

      } else if (this.bookingObject.caseId && !this.caseChange) {
        params.Booking.CaseID = this.bookingObject.caseId
        params.Case = {}
        params.Case.ClaimantFirstName = this.booking.claimantFirstName.trim()
        params.Case.ClaimantGivenNames = this.booking.claimantGivenNames
        params.Case.ClaimantSurname = this.booking.claimantSurname.trim()
        params.Case.ClientID = this.client.id
        params.Case.DateofBirth = moment(this.booking.dateOfBirth, "YYYY-MM-DD").format('YYYY-MM-DD')
        params.Case.ClaimantPhone1 = utilities.validatePhonenumber(this.booking.claimantPhone1)
        params.Case.ClaimantPhone2 = utilities.validatePhonenumber(this.booking.claimantPhone2)
        params.Case.ClaimantMobile = utilities.updateMobileCode(utilities.validatePhonenumber(this.booking.claimantMobile))
        params.Case.ClaimantEmail = this.booking.claimantEmail || undefined
      }

      if (!this.booking.specialistAvailabilityId) {
        params.Booking.BookingDateTime = ""
      }

      if(params.BookingStatus === 3) {
        params.BookingStatusName = 'Booked'
      }

      let obj = {...params}
      for (let key in obj.Booking) {
        if (obj.Booking[key] === null || obj.Booking[key] === '') {
          delete obj.Booking[key];
        }
      }

      // Pass it to API
      var result = await utilities.postBooking(obj, cb)
      if (result) {
        if(this.booking.bookingFiles.length > 0) {
          let item
          await Promise.all(this.booking.bookingFiles.map(async (x) => {
            if(this.booking.id != '') {
              if (!x.isHide) {
                try {
                  const mimeType = await utilities.getFileMimeType(x.file, x.mimeType || 'application/octet-stream')
                  const result = await utilities.postPreSign({
                    ft: mimeType,
                    fn: x.fileName,
                    id: this.booking.id,
                    FileStatus: x.fileStatus,
                    FileTypeID: x.fileTypeId,
                  })
                  let postData = new FormData()
                  for (let key in result.fields) {
                    postData.append(key, result.fields[key]);
                  }
                  postData.append('file', x.file)
                  const r = await utilities.postImage(result.url, postData)
                  if(r) {
                    item = {
                      BookingID: this.booking.id,
                      FileName: x.fileName,
                      FileStatus: x.fileStatus,
                      FileTypeID: x.fileTypeId,
                      MimeType: mimeType,
                    }
                    await utilities.postFileRecord(item)
                  }
                } catch (error) {
                  utilities.showErrorMessage(error.response.data?.message || error.response.data || error)
                }
              }
            }
          }))
        }

        //Call booking request file move API
        if (this.bookingRequest && this.bookingRequest.bookingRequestFile && this.bookingRequest.bookingRequestFile.length > 0) {
           await this.postBookingFile()
        }

        //Need to set booking request as completed when convert booking request into the booking.
        if (this.bookingRequest.id) {
          this.putBookingRequest()
        }

        let addition = false
        if (this.booking.bookingTypeId === 17 && this.bookingObject.additionAvalabilityID) {
          const objCopy = {...obj}
          objCopy.Booking.AvailabilityID = this.bookingObject.additionAvalabilityID
          objCopy.Booking.SpecialistID = this.bookingObject.additionId
          objCopy.Booking.LocationID = this.bookingObject.additionLocationID
          objCopy.Booking.ParentIMEPlusBookingID = this.booking.id
          objCopy.Booking.BookingEndTime = this.bookingObject.additionEndTime
          objCopy.Booking.CaseID = this.booking.CaseID
          let bookingDateTime = this.bookingObject.additionBookingDate + " " + this.bookingObject.additionalStartTime
          objCopy.Booking.BookingDateTime = bookingDateTime ? window.moment(bookingDateTime, 'YYYY-MM-DD hh:mm:ss A').format("YYYY-MM-DD HH:mm:ss") : ''
          await utilities.postBooking(objCopy, (id) => {
            addition = id
          })
        }

        this.$store.dispatch("booking/setBookingObject", null)

        this.successMessage = addition ? `IME Plus booking - associated booking ID is ${addition}`: "Booking details created."
        if(addition) {
          this.$alert(this.successMessage, 'Booking created', {
            confirmButtonText: 'OK',
            type: 'success'
          })
        } else {
          utilities.showAlert(".alert-success")
        }


        setTimeout(() => {
          this.$router.push({ name: 'admin-manage-booking', query: { id: this.booking.id } })
          this.$store.dispatch("loading/setLoadComponent", false)
        }, 2000)
      } else {
        this.errorMessage = "An error occurred."
        utilities.showAlert(".alert-danger")
        this.$store.dispatch("loading/setLoadComponent", false)
      }
      // Process response
    },

    //Call this APi to move booking request file into to booking
    async postBookingFile() {
      var params = {
        BookingID: this.booking.id,
        BookingRequestID: this.bookingRequest.id,
        MoveObject: [],
      }

      this.bookingRequest.bookingRequestFile.map((x) => {
        params.MoveObject.push({
          BookingRequestFileID: x.bookingRequestFileId,
          BookingID: this.booking.id,
          FileName: x.fileName,
          FileTypeID: x.fileTypeId,
          FileStatus: 1,
        })
      })
      await utilities.postBookingFile(params)
    },

    putBookingRequest() {
      var params = {
        // Completed
        BookingRequestStatus: 3,
      }
      var callback = (response) => {}
      return utilities.putBookingRequest(this.bookingRequest.id, params, callback)
    },

    goToCase(caseId) {
      this.$router
        .push({ path: "/admin-manage-case", query: { caseId: caseId } })
        .catch((err) => {});
    },

    requestAction() {
      this.$refs.requestActionModal.handleModal();
    },

    async actionConfirmation(isNew = true) {
      if (isNew) {
        this.successMessage = "Your update has been saved.";
        utilities.showAlert(".alert-success");
      }
      this.bookingAction = await utilities.getBookingActions(this.booking.id);
    },

    // async updateNotify(mode) {
    //   await this.createBooking();
    //   if (mode == "client") {
    //     var params = {
    //       EmailTo: this.emails.client,
    //       Content:
    //         "Your booking with id " + this.booking.id + " has been updated.",
    //       Subject: "RedHealth Booking Updated",
    //     };
    //     var res = await utilities.sendEmailFromBooking(params);
    //     if (res) {
    //       this.successMessage = "Email sent to " + this.sendToProps + ".";
    //       utilities.showAlert(".alert-success");
    //       this.handleModal();
    //     }
    //   } else {
    //     var params = {
    //       EmailTo: this.emails.specialist,
    //       Content:
    //         "Your booking with id " + this.booking.id + " has been updated.",
    //       Subject: "RedHealth Booking Updated",
    //     };
    //     var res = await utilities.sendEmailFromBooking(params);
    //     if (res) {
    //       this.successMessage = "Email sent to " + this.sendToProps + ".";
    //       utilities.showAlert(".alert-success");
    //       this.handleModal();
    //     }
    //   }
    // },
    async changeClient() {
      await this.$store.dispatch("loading/setLoadComponent", true);

      const s = await utilities.choiceGetContact(this.booking.clientId)
      this.clientContacts = _.cloneDeep(utilities.getClientsDropdownAutoCompleteTag(s, false))

      this.originalClientContacts = _.cloneDeep(utilities.getClientsContactDropdownAutoCompleteTag(this.clientContacts))

      this.listContact = _.cloneDeep(this.originalClientContacts)

      this.listBillTo =  _.cloneDeep(this.clientContacts)
      this.listCases = this.originalListCases

      if (this.bookingObject.ClientContactID !== undefined || this.bookingObject.ClientContactID !== '') {
        this.booking.clientContact = this.bookingObject.ClientContactID
      }
      await this.$store.dispatch("loading/setLoadComponent", false);

    },
    async changeCase() {
      this.$store.dispatch("loading/setLoadComponent", true)
      this.clientCase = await utilities.getCaseByCaseId(this.clientCase.id)
      if (this.clientCase.bodyAreas.length > 0) {
        this.bodyAreasTags = utilities.getAutoCompleteBodyAreaTags(this.clientCase.bodyAreas)
      }
      if (this.clientCase.bodyAreaOther.length > 0) {
        this.otherBodyAreasTags = utilities.getAutoCompleteOtherBodyAreaTags(this.clientCase.bodyAreaOther.split(','))
      }

      if (this.clientCase.personCondition.length > 0) {
        this.conditionTags = utilities.getAutoCompleteTags(this.clientCase.personCondition)
      }
      this.$store.dispatch("loading/setLoadComponent", false)
    },

    // updateBookingTime() {
    //   if (this.bookingTime != "manual")
    //     this.booking.bookingTime = this.timeSlots.find(
    //       (x) => x.time == this.bookingTime
    //     ).time;
    // },

    async changeSpecialist() {
      // Enable date and time if specialistId != ''
      this.specialist.settings = await utilities.getSpecialistSettings(this.bookingObject.id);
      //this.specialist = this.specialists.find((x) => x.id == this.specialist.id)
    },

    changeBookingStatusName() {
      this.booking.bookingStatusName = this.bookingStatuses.find(
        (x) => x.id === this.booking.bookingStatus
      ).name;
    },

    isDate(date) {
      return moment(date, "YYYY-MM-DD").isValid()
    },

    setBookingDetails(object) {
      this.booking.specialistAvailabilityId = object.availabilityId
      this.booking.locationId = object.locationId != undefined ? object.locationId : ''
      this.booking.bookingDate = window.moment(object.bookingDate, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY")
      this.booking.bookingTime = window.moment(object.bookingTime, 'hh:mm').format('HH:mm:ss')
      this.booking.bookingEndTime = object.bookingEndTime
      this.booking.specialistAvailabilityId = object.availabilityId
      this.booking.bookingTypeId = object.typeId
      this.booking.claimTypeId = object.ClaimTypeID
      this.booking.ClientReference = object.ClientReference
      this.booking.IncidentState = object.IncidentState
      this.booking.accidentDate = object.AccidentDate
      this.booking.overPeriodofTime = !!object.OverPeriodofTime
      this.bookingWithNoAvailability = !utilities.bookingTypeWithAvailability(object.typeId)
      if(this.booking.bookingTypeId === 8) {
        this.booking.SuppFutureDate = window.moment().format('YYYY-MM-DD HH:mm')
      }
      // tpd
      if(this.booking.bookingTypeId === 19) {
        this.booking.claimTypeId = 3
      }
      this.booking.DeliveryMethodID = object.defaultDeliveryMethod
      this.deliveryMethods = object.deliveryMethods ? object.deliveryMethods.map(item => {
        return {
          value: item,
          label : item === 1 ? 'In-person' : 'Virtual',
          des: item === 1 ? 'his service will be delivered face to face with the Medical Expert' : 'This service will be delivered by videolink only.'
        }
      }) : []
      this.checkBookingType()

      if(object.waitlisted) {
        var dateTime = this.booking.bookingDate + " " + object.bookingTime
        this.booking.bookingDateTime = window.moment(dateTime, 'DD/MM/YYYY HH:mm').format("YYYY-MM-DD HH:mm:ss")
      } else {
        var bookingDateTime = object.bookingDate + " " + object.bookingTime
        this.booking.bookingDateTime = bookingDateTime.trim() ? window.moment(bookingDateTime, 'YYYY-MM-DD hh:mm:ss A').format("YYYY-MM-DD HH:mm:ss"): ''
        console.log(bookingDateTime)
      }

      if (this.booking.bookingDateTime && !this.isTPD ) {
        this.booking.paperworkDue = window.moment(this.booking.bookingDateTime, 'YYYY-MM-DD').businessSubtract(10).format("DD/MM/YYYY")
      }
      if ((object.clientId !== undefined || object.clientId !== '')) {
        this.booking.clientId = object.clientId
      }

      if(object.ClientContactID) {
        this.booking.clientContact = object.ClientContactID
      }
      //this.client.id = selectedClient.id

      this.booking.specialistId = object.id
      if(object.isSupplementary) {
        this.bookingTypes = this.bookingTypes.filter(item => object.serviceTypes.includes(item.id))
      } else {
        this.bookingTypes = this.bookingTypes.filter(item => this.booking.bookingTypeId === item.id)
      }

      this.checkBookingType()


      //set Search case details
      if (object.isNewCase) {
        if (object.claimantFirstName || object.claimantLastName) {
          this.booking.claimantFirstName = object.claimantFirstName
          this.booking.claimantSurname = object.claimantLastName
          this.booking.claimantFullName = utilities.getClaimantFullName(this.booking)
          if (this.booking.claimantFullName) {
            this.isEditName = true
          } else {
            this.isEditName = false
          }
        }

        if (object.dateOfBirth) {
          this.booking.dateOfBirth = object.dateOfBirth
        }

      } else {
        this.booking.caseOwnerName = object.caseOwnerName
      }

      this.checkReassessments()
      this.nameKey ++;
      this.$forceUpdate()
    },

    setBookingRequestDetails() {
      this.bookingObject.clientId = this.bookingRequest.clientId
      this.booking.claimantFirstName = this.bookingRequest.claimantFirstName
      this.booking.claimantGivenNames = this.bookingRequest.claimantGivenNames
      this.booking.claimantSurname = this.bookingRequest.claimantSurname
      this.booking.claimantFullName = utilities.getClaimantFullName(this.bookingRequest)
      this.booking.dateOfBirth = this.bookingRequest.dateOfBirth
      this.booking.claimTypeId = this.bookingRequest.claimTypeId
      this.booking.claimTypeName = this.bookingRequest.claimTypeName
      this.booking.bookingTypeId = this.bookingRequest.bookingTypeId
      this.booking.ClientReference = this.bookingRequest.ClientReference
      this.booking.IncidentState = this.bookingRequest.IncidentState
      if(this.bookingRequest.bookingTypeId === 19) {
        this.showMAS = this.bookingRequest.MAS > 0
        this.showPIC = this.bookingRequest.PIC > 0
        this.showSHORT = this.bookingRequest.ShortReport > 0
        this.booking.MAS = this.bookingRequest.MAS
        this.booking.PIC = this.bookingRequest.PIC
        this.booking.ShortReport = this.bookingRequest.ShortReport
      }
      this.deliveryMethods = this.bookingRequest.DeliveryMethodIDs ? this.bookingRequest.DeliveryMethodIDs.map(item => {
        return {
          value: item.DeliveryMethodID,
          label : item.DeliveryMethodID === 1 ? 'In-person' : 'Virtual',
          des: item.DeliveryMethodID === 1 ? 'his service will be delivered face to face with the Medical Expert' : 'This service will be delivered by videolink only.'
        }
      }) : []
      if (this.bookingRequest.bodyAreas.length > 0) {
        var temp = []
        this.bookingRequest.bodyAreas.map((x) => {
          var item = {
            id: x.bodyAreaId,
            value: x.bodyAreaId,
            text: x.bodyArea
          }
          temp.push(item)
        })
        this.bodyAreaTags = temp
      }

      if (this.bookingRequest.bodyAreaOther.length > 0) {
        var items = this.bookingRequest.bodyAreaOther.split(',');
        this.otherBodyAreaTags = utilities.getAutoCompleteOtherBodyAreaTags(items)
      }

      if (this.bookingRequest.personConditions.length > 0) {
        var temp = []
        this.bookingRequest.personConditions.map((x) => {
          temp.push(x.personConditionId,)
        })
        this.booking.PersonConditions = temp
      }

      if (this.bookingRequest.note) {
        var note = {
          userName: this.bookingRequest.submitByUser,
          noteDateTime: this.formatDate(this.bookingRequest.dateSubmitted, 'YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss.ssssss'),
          note: this.bookingRequest.note,
          isHide: true,
          userId: this.bookingRequest.submittedBy
        }
        this.booking.bookingNotes.push(note)
      }
      if (this.bookingRequest && this.bookingRequest.bookingRequestFile && this.bookingRequest.bookingRequestFile.length > 0) {
        this.bookingRequest.bookingRequestFile.map((x) => {
          var file = {
            fileStatus: 1,
            fileTypeId: x.fileTypeId,
            fileName: x.fileName,
            uploadedByName:x.uploadedByName,
            uploadedBy: x.uploadedBy,
            isHide: true,
          }
          this.booking.bookingFiles.push(file)
        })
      }

      if (this.booking.claimantFullName) {
        this.isEditName = true
      } else {
        this.isEditName = false
      }
      this.fileKey += 1
    },
  },
  async beforeMount() {
    this.bookingObject = this.$store.getters["booking/getBookingObject"]
    if (this.bookingObject.bookingRequestId) {
      this.bookingRequest = await utilities.getBookingRequestById(this.bookingObject.bookingRequestId)
    } else {
      this.clientCase.id = this.bookingObject.caseId
    }

    await this.$store.dispatch('loading/setLoadComponent', true)
    await this.loadData()

    if (this.bookingObject.noResult) {
      utilities.showDialogInfo('No matching claimants found; please enter the details for the new claimant.')
    }
    if (this.bookingRequest.id) {
      this.setBookingRequestDetails()
    }
    this.setBookingDetails(this.bookingObject)
    this.openTab(0)
    await this.$store.dispatch('loading/setLoadComponent', false)
  },
  mounted() {
    setTimeout(() => {
      $(".dropdown-input").attr({
       autocomplete: "off",
      })

      this.defineClearButton()
    }, 500)
  },
};
</script>
<style scoped>
.default-checkbox.tick {
  margin-left: 20px;
  margin-right: 20px;
  height: 40px;
}
::v-deep .el-input-number .el-input__inner {
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
